/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex-schema'

const $nsid = 'id.sifa.defs'

type $nsid = typeof $nsid

export { $nsid }

/** The type of employment arrangement. */
type EmploymentType =
  | 'id.sifa.defs#fullTime'
  | 'id.sifa.defs#partTime'
  | 'id.sifa.defs#temporary'
  | 'id.sifa.defs#seasonal'
  | 'id.sifa.defs#contract'
  | 'id.sifa.defs#freelance'
  | 'id.sifa.defs#selfEmployed'
  | 'id.sifa.defs#independentWork'
  | 'id.sifa.defs#internship'
  | 'id.sifa.defs#apprenticeship'
  | 'id.sifa.defs#fellowship'
  | 'id.sifa.defs#trainee'
  | 'id.sifa.defs#volunteer'
  | 'id.sifa.defs#boardMember'
  | 'id.sifa.defs#boardObserver'
  | 'id.sifa.defs#advisor'
  | l.UnknownString

export type { EmploymentType }

/** The type of employment arrangement. */
const employmentType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#fullTime',
    'id.sifa.defs#partTime',
    'id.sifa.defs#temporary',
    'id.sifa.defs#seasonal',
    'id.sifa.defs#contract',
    'id.sifa.defs#freelance',
    'id.sifa.defs#selfEmployed',
    'id.sifa.defs#independentWork',
    'id.sifa.defs#internship',
    'id.sifa.defs#apprenticeship',
    'id.sifa.defs#fellowship',
    'id.sifa.defs#trainee',
    'id.sifa.defs#volunteer',
    'id.sifa.defs#boardMember',
    'id.sifa.defs#boardObserver',
    'id.sifa.defs#advisor',
  ]
}>()

export { employmentType }

/** Full-time employee of the organization. */
const fullTime = /*#__PURE__*/ l.token($nsid, 'fullTime')

export { fullTime }

/** Full-time employee of the organization. */
const FullTime = /*#__PURE__*/ fullTime.value

/** Full-time employee of the organization. */
type FullTime = typeof FullTime

export { FullTime }

/** Part-time employee of the organization. */
const partTime = /*#__PURE__*/ l.token($nsid, 'partTime')

export { partTime }

/** Part-time employee of the organization. */
const PartTime = /*#__PURE__*/ partTime.value

/** Part-time employee of the organization. */
type PartTime = typeof PartTime

export { PartTime }

/** Fixed-end-date role as a direct employee of the organization. */
const temporary = /*#__PURE__*/ l.token($nsid, 'temporary')

export { temporary }

/** Fixed-end-date role as a direct employee of the organization. */
const Temporary = /*#__PURE__*/ temporary.value

/** Fixed-end-date role as a direct employee of the organization. */
type Temporary = typeof Temporary

export { Temporary }

/** Recurring role tied to a season or peak period. */
const seasonal = /*#__PURE__*/ l.token($nsid, 'seasonal')

export { seasonal }

/** Recurring role tied to a season or peak period. */
const Seasonal = /*#__PURE__*/ seasonal.value

/** Recurring role tied to a season or peak period. */
type Seasonal = typeof Seasonal

export { Seasonal }

/** Fixed-scope engagement as an independent contractor. */
const contract = /*#__PURE__*/ l.token($nsid, 'contract')

export { contract }

/** Fixed-scope engagement as an independent contractor. */
const Contract = /*#__PURE__*/ contract.value

/** Fixed-scope engagement as an independent contractor. */
type Contract = typeof Contract

export { Contract }

/** Solo service provider working with multiple clients on a project basis. No employees. */
const freelance = /*#__PURE__*/ l.token($nsid, 'freelance')

export { freelance }

/** Solo service provider working with multiple clients on a project basis. No employees. */
const Freelance = /*#__PURE__*/ freelance.value

/** Solo service provider working with multiple clients on a project basis. No employees. */
type Freelance = typeof Freelance

export { Freelance }

/** Operating your own business or practice. May have employees. */
const selfEmployed = /*#__PURE__*/ l.token($nsid, 'selfEmployed')

export { selfEmployed }

/** Operating your own business or practice. May have employees. */
const SelfEmployed = /*#__PURE__*/ selfEmployed.value

/** Operating your own business or practice. May have employees. */
type SelfEmployed = typeof SelfEmployed

export { SelfEmployed }

/** Self-initiated, sustained work I lead — community building, content creation, ecosystem contribution, or similar. May involve a registered entity but does not pay me personally. Often run alongside other employment. */
const independentWork = /*#__PURE__*/ l.token($nsid, 'independentWork')

export { independentWork }

/** Self-initiated, sustained work I lead — community building, content creation, ecosystem contribution, or similar. May involve a registered entity but does not pay me personally. Often run alongside other employment. */
const IndependentWork = /*#__PURE__*/ independentWork.value

/** Self-initiated, sustained work I lead — community building, content creation, ecosystem contribution, or similar. May involve a registered entity but does not pay me personally. Often run alongside other employment. */
type IndependentWork = typeof IndependentWork

export { IndependentWork }

/** Structured early-career work experience, often tied to studies. */
const internship = /*#__PURE__*/ l.token($nsid, 'internship')

export { internship }

/** Structured early-career work experience, often tied to studies. */
const Internship = /*#__PURE__*/ internship.value

/** Structured early-career work experience, often tied to studies. */
type Internship = typeof Internship

export { Internship }

/** Formal training-to-certification program combining paid work and education. */
const apprenticeship = /*#__PURE__*/ l.token($nsid, 'apprenticeship')

export { apprenticeship }

/** Formal training-to-certification program combining paid work and education. */
const Apprenticeship = /*#__PURE__*/ apprenticeship.value

/** Formal training-to-certification program combining paid work and education. */
type Apprenticeship = typeof Apprenticeship

export { Apprenticeship }

/** Funded research, academic, or mission-driven position, typically selective. */
const fellowship = /*#__PURE__*/ l.token($nsid, 'fellowship')

export { fellowship }

/** Funded research, academic, or mission-driven position, typically selective. */
const Fellowship = /*#__PURE__*/ fellowship.value

/** Funded research, academic, or mission-driven position, typically selective. */
type Fellowship = typeof Fellowship

export { Fellowship }

/** Structured early-career rotation or graduate program. */
const trainee = /*#__PURE__*/ l.token($nsid, 'trainee')

export { trainee }

/** Structured early-career rotation or graduate program. */
const Trainee = /*#__PURE__*/ trainee.value

/** Structured early-career rotation or graduate program. */
type Trainee = typeof Trainee

export { Trainee }

/** Volunteer work (when used as employment type). */
const volunteer = /*#__PURE__*/ l.token($nsid, 'volunteer')

export { volunteer }

/** Volunteer work (when used as employment type). */
const Volunteer = /*#__PURE__*/ volunteer.value

/** Volunteer work (when used as employment type). */
type Volunteer = typeof Volunteer

export { Volunteer }

/** Seat on a board of directors or supervisory board, carrying a vote and fiduciary duty. Usually not employment, in the same way volunteer is not. */
const boardMember = /*#__PURE__*/ l.token($nsid, 'boardMember')

export { boardMember }

/** Seat on a board of directors or supervisory board, carrying a vote and fiduciary duty. Usually not employment, in the same way volunteer is not. */
const BoardMember = /*#__PURE__*/ boardMember.value

/** Seat on a board of directors or supervisory board, carrying a vote and fiduciary duty. Usually not employment, in the same way volunteer is not. */
type BoardMember = typeof BoardMember

export { BoardMember }

/** Board observer seat: attends and is informed but holds no vote. The common shape of an investor seat, kept distinct so it does not read as directorship. */
const boardObserver = /*#__PURE__*/ l.token($nsid, 'boardObserver')

export { boardObserver }

/** Board observer seat: attends and is informed but holds no vote. The common shape of an investor seat, kept distinct so it does not read as directorship. */
const BoardObserver = /*#__PURE__*/ boardObserver.value

/** Board observer seat: attends and is informed but holds no vote. The common shape of an investor seat, kept distinct so it does not read as directorship. */
type BoardObserver = typeof BoardObserver

export { BoardObserver }

/** Advisory role, paid or unpaid, without a board seat or line responsibility. */
const advisor = /*#__PURE__*/ l.token($nsid, 'advisor')

export { advisor }

/** Advisory role, paid or unpaid, without a board seat or line responsibility. */
const Advisor = /*#__PURE__*/ advisor.value

/** Advisory role, paid or unpaid, without a board seat or line responsibility. */
type Advisor = typeof Advisor

export { Advisor }

/** The workplace arrangement. */
type WorkplaceType =
  | 'id.sifa.defs#onSite'
  | 'id.sifa.defs#remote'
  | 'id.sifa.defs#hybrid'
  | 'id.sifa.defs#remoteLocal'
  | 'id.sifa.defs#remoteRegion'
  | 'id.sifa.defs#remoteGlobal'
  | l.UnknownString

export type { WorkplaceType }

/** The workplace arrangement. */
const workplaceType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#onSite',
    'id.sifa.defs#remote',
    'id.sifa.defs#hybrid',
    'id.sifa.defs#remoteLocal',
    'id.sifa.defs#remoteRegion',
    'id.sifa.defs#remoteGlobal',
  ]
}>()

export { workplaceType }

/** On-site/in-office work. */
const onSite = /*#__PURE__*/ l.token($nsid, 'onSite')

export { onSite }

/** On-site/in-office work. */
const OnSite = /*#__PURE__*/ onSite.value

/** On-site/in-office work. */
type OnSite = typeof OnSite

export { OnSite }

/** Fully remote work (unspecified scope). Treated as remoteGlobal by AppViews. Prefer the scoped variants for new records. */
const remote = /*#__PURE__*/ l.token($nsid, 'remote')

export { remote }

/** Fully remote work (unspecified scope). Treated as remoteGlobal by AppViews. Prefer the scoped variants for new records. */
const Remote = /*#__PURE__*/ remote.value

/** Fully remote work (unspecified scope). Treated as remoteGlobal by AppViews. Prefer the scoped variants for new records. */
type Remote = typeof Remote

export { Remote }

/** Hybrid on-site and remote work. */
const hybrid = /*#__PURE__*/ l.token($nsid, 'hybrid')

export { hybrid }

/** Hybrid on-site and remote work. */
const Hybrid = /*#__PURE__*/ hybrid.value

/** Hybrid on-site and remote work. */
type Hybrid = typeof Hybrid

export { Hybrid }

/** Remote work within the same country as the employer. */
const remoteLocal = /*#__PURE__*/ l.token($nsid, 'remoteLocal')

export { remoteLocal }

/** Remote work within the same country as the employer. */
const RemoteLocal = /*#__PURE__*/ remoteLocal.value

/** Remote work within the same country as the employer. */
type RemoteLocal = typeof RemoteLocal

export { RemoteLocal }

/** Remote work within the same timezone region or continent. */
const remoteRegion = /*#__PURE__*/ l.token($nsid, 'remoteRegion')

export { remoteRegion }

/** Remote work within the same timezone region or continent. */
const RemoteRegion = /*#__PURE__*/ remoteRegion.value

/** Remote work within the same timezone region or continent. */
type RemoteRegion = typeof RemoteRegion

export { RemoteRegion }

/** Remote work from anywhere worldwide. */
const remoteGlobal = /*#__PURE__*/ l.token($nsid, 'remoteGlobal')

export { remoteGlobal }

/** Remote work from anywhere worldwide. */
const RemoteGlobal = /*#__PURE__*/ remoteGlobal.value

/** Remote work from anywhere worldwide. */
type RemoteGlobal = typeof RemoteGlobal

export { RemoteGlobal }

/** Professional industry sector. */
type IndustryType =
  | 'id.sifa.defs#industryTechnology'
  | 'id.sifa.defs#industryFinance'
  | 'id.sifa.defs#industryHealthcare'
  | 'id.sifa.defs#industryEducation'
  | 'id.sifa.defs#industryMedia'
  | 'id.sifa.defs#industryRetail'
  | 'id.sifa.defs#industryManufacturing'
  | 'id.sifa.defs#industryEnergy'
  | 'id.sifa.defs#industryGovernment'
  | 'id.sifa.defs#industryLegal'
  | 'id.sifa.defs#industryConsulting'
  | 'id.sifa.defs#industryNonprofit'
  | 'id.sifa.defs#industryRealEstate'
  | 'id.sifa.defs#industryTransport'
  | 'id.sifa.defs#industryAgriculture'
  | 'id.sifa.defs#industryHospitality'
  | 'id.sifa.defs#industryTelecom'
  | 'id.sifa.defs#industryMining'
  | 'id.sifa.defs#industryFashion'
  | 'id.sifa.defs#industryMaritime'
  | 'id.sifa.defs#industryOther'
  | l.UnknownString

export type { IndustryType }

/** Professional industry sector. */
const industryType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#industryTechnology',
    'id.sifa.defs#industryFinance',
    'id.sifa.defs#industryHealthcare',
    'id.sifa.defs#industryEducation',
    'id.sifa.defs#industryMedia',
    'id.sifa.defs#industryRetail',
    'id.sifa.defs#industryManufacturing',
    'id.sifa.defs#industryEnergy',
    'id.sifa.defs#industryGovernment',
    'id.sifa.defs#industryLegal',
    'id.sifa.defs#industryConsulting',
    'id.sifa.defs#industryNonprofit',
    'id.sifa.defs#industryRealEstate',
    'id.sifa.defs#industryTransport',
    'id.sifa.defs#industryAgriculture',
    'id.sifa.defs#industryHospitality',
    'id.sifa.defs#industryTelecom',
    'id.sifa.defs#industryMining',
    'id.sifa.defs#industryFashion',
    'id.sifa.defs#industryMaritime',
    'id.sifa.defs#industryOther',
  ]
}>()

export { industryType }

/** Technology. */
const industryTechnology = /*#__PURE__*/ l.token($nsid, 'industryTechnology')

export { industryTechnology }

/** Technology. */
const IndustryTechnology = /*#__PURE__*/ industryTechnology.value

/** Technology. */
type IndustryTechnology = typeof IndustryTechnology

export { IndustryTechnology }

/** Finance & Banking. */
const industryFinance = /*#__PURE__*/ l.token($nsid, 'industryFinance')

export { industryFinance }

/** Finance & Banking. */
const IndustryFinance = /*#__PURE__*/ industryFinance.value

/** Finance & Banking. */
type IndustryFinance = typeof IndustryFinance

export { IndustryFinance }

/** Healthcare & Life Sciences. */
const industryHealthcare = /*#__PURE__*/ l.token($nsid, 'industryHealthcare')

export { industryHealthcare }

/** Healthcare & Life Sciences. */
const IndustryHealthcare = /*#__PURE__*/ industryHealthcare.value

/** Healthcare & Life Sciences. */
type IndustryHealthcare = typeof IndustryHealthcare

export { IndustryHealthcare }

/** Education & Research. */
const industryEducation = /*#__PURE__*/ l.token($nsid, 'industryEducation')

export { industryEducation }

/** Education & Research. */
const IndustryEducation = /*#__PURE__*/ industryEducation.value

/** Education & Research. */
type IndustryEducation = typeof IndustryEducation

export { IndustryEducation }

/** Media & Entertainment. */
const industryMedia = /*#__PURE__*/ l.token($nsid, 'industryMedia')

export { industryMedia }

/** Media & Entertainment. */
const IndustryMedia = /*#__PURE__*/ industryMedia.value

/** Media & Entertainment. */
type IndustryMedia = typeof IndustryMedia

export { IndustryMedia }

/** Retail & E-commerce. */
const industryRetail = /*#__PURE__*/ l.token($nsid, 'industryRetail')

export { industryRetail }

/** Retail & E-commerce. */
const IndustryRetail = /*#__PURE__*/ industryRetail.value

/** Retail & E-commerce. */
type IndustryRetail = typeof IndustryRetail

export { IndustryRetail }

/** Manufacturing & Engineering. */
const industryManufacturing = /*#__PURE__*/ l.token(
  $nsid,
  'industryManufacturing',
)

export { industryManufacturing }

/** Manufacturing & Engineering. */
const IndustryManufacturing = /*#__PURE__*/ industryManufacturing.value

/** Manufacturing & Engineering. */
type IndustryManufacturing = typeof IndustryManufacturing

export { IndustryManufacturing }

/** Energy & Environment. */
const industryEnergy = /*#__PURE__*/ l.token($nsid, 'industryEnergy')

export { industryEnergy }

/** Energy & Environment. */
const IndustryEnergy = /*#__PURE__*/ industryEnergy.value

/** Energy & Environment. */
type IndustryEnergy = typeof IndustryEnergy

export { IndustryEnergy }

/** Government & Public Sector. */
const industryGovernment = /*#__PURE__*/ l.token($nsid, 'industryGovernment')

export { industryGovernment }

/** Government & Public Sector. */
const IndustryGovernment = /*#__PURE__*/ industryGovernment.value

/** Government & Public Sector. */
type IndustryGovernment = typeof IndustryGovernment

export { IndustryGovernment }

/** Legal. */
const industryLegal = /*#__PURE__*/ l.token($nsid, 'industryLegal')

export { industryLegal }

/** Legal. */
const IndustryLegal = /*#__PURE__*/ industryLegal.value

/** Legal. */
type IndustryLegal = typeof IndustryLegal

export { IndustryLegal }

/** Consulting & Professional Services. */
const industryConsulting = /*#__PURE__*/ l.token($nsid, 'industryConsulting')

export { industryConsulting }

/** Consulting & Professional Services. */
const IndustryConsulting = /*#__PURE__*/ industryConsulting.value

/** Consulting & Professional Services. */
type IndustryConsulting = typeof IndustryConsulting

export { IndustryConsulting }

/** Non-profit & Social Impact. */
const industryNonprofit = /*#__PURE__*/ l.token($nsid, 'industryNonprofit')

export { industryNonprofit }

/** Non-profit & Social Impact. */
const IndustryNonprofit = /*#__PURE__*/ industryNonprofit.value

/** Non-profit & Social Impact. */
type IndustryNonprofit = typeof IndustryNonprofit

export { IndustryNonprofit }

/** Real Estate & Construction. */
const industryRealEstate = /*#__PURE__*/ l.token($nsid, 'industryRealEstate')

export { industryRealEstate }

/** Real Estate & Construction. */
const IndustryRealEstate = /*#__PURE__*/ industryRealEstate.value

/** Real Estate & Construction. */
type IndustryRealEstate = typeof IndustryRealEstate

export { IndustryRealEstate }

/** Transportation & Logistics. */
const industryTransport = /*#__PURE__*/ l.token($nsid, 'industryTransport')

export { industryTransport }

/** Transportation & Logistics. */
const IndustryTransport = /*#__PURE__*/ industryTransport.value

/** Transportation & Logistics. */
type IndustryTransport = typeof IndustryTransport

export { IndustryTransport }

/** Agriculture & Food. */
const industryAgriculture = /*#__PURE__*/ l.token($nsid, 'industryAgriculture')

export { industryAgriculture }

/** Agriculture & Food. */
const IndustryAgriculture = /*#__PURE__*/ industryAgriculture.value

/** Agriculture & Food. */
type IndustryAgriculture = typeof IndustryAgriculture

export { IndustryAgriculture }

/** Hospitality & Tourism. */
const industryHospitality = /*#__PURE__*/ l.token($nsid, 'industryHospitality')

export { industryHospitality }

/** Hospitality & Tourism. */
const IndustryHospitality = /*#__PURE__*/ industryHospitality.value

/** Hospitality & Tourism. */
type IndustryHospitality = typeof IndustryHospitality

export { IndustryHospitality }

/** Telecommunications. */
const industryTelecom = /*#__PURE__*/ l.token($nsid, 'industryTelecom')

export { industryTelecom }

/** Telecommunications. */
const IndustryTelecom = /*#__PURE__*/ industryTelecom.value

/** Telecommunications. */
type IndustryTelecom = typeof IndustryTelecom

export { IndustryTelecom }

/** Mining & Resources. */
const industryMining = /*#__PURE__*/ l.token($nsid, 'industryMining')

export { industryMining }

/** Mining & Resources. */
const IndustryMining = /*#__PURE__*/ industryMining.value

/** Mining & Resources. */
type IndustryMining = typeof IndustryMining

export { IndustryMining }

/** Fashion & Textiles. */
const industryFashion = /*#__PURE__*/ l.token($nsid, 'industryFashion')

export { industryFashion }

/** Fashion & Textiles. */
const IndustryFashion = /*#__PURE__*/ industryFashion.value

/** Fashion & Textiles. */
type IndustryFashion = typeof IndustryFashion

export { IndustryFashion }

/** Maritime & Shipping. */
const industryMaritime = /*#__PURE__*/ l.token($nsid, 'industryMaritime')

export { industryMaritime }

/** Maritime & Shipping. */
const IndustryMaritime = /*#__PURE__*/ industryMaritime.value

/** Maritime & Shipping. */
type IndustryMaritime = typeof IndustryMaritime

export { IndustryMaritime }

/** Other industry. */
const industryOther = /*#__PURE__*/ l.token($nsid, 'industryOther')

export { industryOther }

/** Other industry. */
const IndustryOther = /*#__PURE__*/ industryOther.value

/** Other industry. */
type IndustryOther = typeof IndustryOther

export { IndustryOther }

/** Professional domain within an industry. Optional refinement of industryType. */
type DomainType =
  | 'id.sifa.defs#domainSoftwareEngineering'
  | 'id.sifa.defs#domainDataScience'
  | 'id.sifa.defs#domainCybersecurity'
  | 'id.sifa.defs#domainDevops'
  | 'id.sifa.defs#domainProductDesign'
  | 'id.sifa.defs#domainGameDev'
  | 'id.sifa.defs#domainBanking'
  | 'id.sifa.defs#domainFintech'
  | 'id.sifa.defs#domainInsurance'
  | 'id.sifa.defs#domainInvestmentMgmt'
  | 'id.sifa.defs#domainClinicalResearch'
  | 'id.sifa.defs#domainHealthtech'
  | 'id.sifa.defs#domainPharma'
  | 'id.sifa.defs#domainHigherEd'
  | 'id.sifa.defs#domainEdtech'
  | 'id.sifa.defs#domainPrimarySecondary'
  | 'id.sifa.defs#domainJournalism'
  | 'id.sifa.defs#domainFilmVideo'
  | 'id.sifa.defs#domainGaming'
  | 'id.sifa.defs#domainAdvertising'
  | 'id.sifa.defs#domainEcommerce'
  | 'id.sifa.defs#domainSupplyChain'
  | 'id.sifa.defs#domainAutomotive'
  | 'id.sifa.defs#domainAerospace'
  | 'id.sifa.defs#domainHardware'
  | 'id.sifa.defs#domainRenewables'
  | 'id.sifa.defs#domainOilGas'
  | 'id.sifa.defs#domainClimateTech'
  | 'id.sifa.defs#domainManagementConsulting'
  | 'id.sifa.defs#domainDevrel'
  | 'id.sifa.defs#domainHrRecruitment'
  | 'id.sifa.defs#domainIpLaw'
  | 'id.sifa.defs#domainCompliance'
  | 'id.sifa.defs#domainHumanRights'
  | 'id.sifa.defs#domainOpenSource'
  | 'id.sifa.defs#domainPublicPolicy'
  | 'id.sifa.defs#domainDefense'
  | 'id.sifa.defs#domainProptech'
  | 'id.sifa.defs#domainAutonomousVehicles'
  | 'id.sifa.defs#domainLogistics'
  | 'id.sifa.defs#domainAgritech'
  | 'id.sifa.defs#domainFoodTech'
  | 'id.sifa.defs#domainHotels'
  | 'id.sifa.defs#domainTravelTourism'
  | 'id.sifa.defs#domainFoodBeverage'
  | 'id.sifa.defs#domainNetworkInfra'
  | 'id.sifa.defs#domainMobileServices'
  | 'id.sifa.defs#domainExtraction'
  | 'id.sifa.defs#domainGeological'
  | 'id.sifa.defs#domainFashionDesign'
  | 'id.sifa.defs#domainTextileManufacturing'
  | 'id.sifa.defs#domainShipping'
  | 'id.sifa.defs#domainPortOperations'
  | 'id.sifa.defs#domainNavalArchitecture'
  | l.UnknownString

export type { DomainType }

/** Professional domain within an industry. Optional refinement of industryType. */
const domainType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#domainSoftwareEngineering',
    'id.sifa.defs#domainDataScience',
    'id.sifa.defs#domainCybersecurity',
    'id.sifa.defs#domainDevops',
    'id.sifa.defs#domainProductDesign',
    'id.sifa.defs#domainGameDev',
    'id.sifa.defs#domainBanking',
    'id.sifa.defs#domainFintech',
    'id.sifa.defs#domainInsurance',
    'id.sifa.defs#domainInvestmentMgmt',
    'id.sifa.defs#domainClinicalResearch',
    'id.sifa.defs#domainHealthtech',
    'id.sifa.defs#domainPharma',
    'id.sifa.defs#domainHigherEd',
    'id.sifa.defs#domainEdtech',
    'id.sifa.defs#domainPrimarySecondary',
    'id.sifa.defs#domainJournalism',
    'id.sifa.defs#domainFilmVideo',
    'id.sifa.defs#domainGaming',
    'id.sifa.defs#domainAdvertising',
    'id.sifa.defs#domainEcommerce',
    'id.sifa.defs#domainSupplyChain',
    'id.sifa.defs#domainAutomotive',
    'id.sifa.defs#domainAerospace',
    'id.sifa.defs#domainHardware',
    'id.sifa.defs#domainRenewables',
    'id.sifa.defs#domainOilGas',
    'id.sifa.defs#domainClimateTech',
    'id.sifa.defs#domainManagementConsulting',
    'id.sifa.defs#domainDevrel',
    'id.sifa.defs#domainHrRecruitment',
    'id.sifa.defs#domainIpLaw',
    'id.sifa.defs#domainCompliance',
    'id.sifa.defs#domainHumanRights',
    'id.sifa.defs#domainOpenSource',
    'id.sifa.defs#domainPublicPolicy',
    'id.sifa.defs#domainDefense',
    'id.sifa.defs#domainProptech',
    'id.sifa.defs#domainAutonomousVehicles',
    'id.sifa.defs#domainLogistics',
    'id.sifa.defs#domainAgritech',
    'id.sifa.defs#domainFoodTech',
    'id.sifa.defs#domainHotels',
    'id.sifa.defs#domainTravelTourism',
    'id.sifa.defs#domainFoodBeverage',
    'id.sifa.defs#domainNetworkInfra',
    'id.sifa.defs#domainMobileServices',
    'id.sifa.defs#domainExtraction',
    'id.sifa.defs#domainGeological',
    'id.sifa.defs#domainFashionDesign',
    'id.sifa.defs#domainTextileManufacturing',
    'id.sifa.defs#domainShipping',
    'id.sifa.defs#domainPortOperations',
    'id.sifa.defs#domainNavalArchitecture',
  ]
}>()

export { domainType }

/** Software Engineering. */
const domainSoftwareEngineering = /*#__PURE__*/ l.token(
  $nsid,
  'domainSoftwareEngineering',
)

export { domainSoftwareEngineering }

/** Software Engineering. */
const DomainSoftwareEngineering = /*#__PURE__*/ domainSoftwareEngineering.value

/** Software Engineering. */
type DomainSoftwareEngineering = typeof DomainSoftwareEngineering

export { DomainSoftwareEngineering }

/** Data Science & ML. */
const domainDataScience = /*#__PURE__*/ l.token($nsid, 'domainDataScience')

export { domainDataScience }

/** Data Science & ML. */
const DomainDataScience = /*#__PURE__*/ domainDataScience.value

/** Data Science & ML. */
type DomainDataScience = typeof DomainDataScience

export { DomainDataScience }

/** Cybersecurity. */
const domainCybersecurity = /*#__PURE__*/ l.token($nsid, 'domainCybersecurity')

export { domainCybersecurity }

/** Cybersecurity. */
const DomainCybersecurity = /*#__PURE__*/ domainCybersecurity.value

/** Cybersecurity. */
type DomainCybersecurity = typeof DomainCybersecurity

export { DomainCybersecurity }

/** DevOps & Infrastructure. */
const domainDevops = /*#__PURE__*/ l.token($nsid, 'domainDevops')

export { domainDevops }

/** DevOps & Infrastructure. */
const DomainDevops = /*#__PURE__*/ domainDevops.value

/** DevOps & Infrastructure. */
type DomainDevops = typeof DomainDevops

export { DomainDevops }

/** Product & UX Design. */
const domainProductDesign = /*#__PURE__*/ l.token($nsid, 'domainProductDesign')

export { domainProductDesign }

/** Product & UX Design. */
const DomainProductDesign = /*#__PURE__*/ domainProductDesign.value

/** Product & UX Design. */
type DomainProductDesign = typeof DomainProductDesign

export { DomainProductDesign }

/** Game Development. */
const domainGameDev = /*#__PURE__*/ l.token($nsid, 'domainGameDev')

export { domainGameDev }

/** Game Development. */
const DomainGameDev = /*#__PURE__*/ domainGameDev.value

/** Game Development. */
type DomainGameDev = typeof DomainGameDev

export { DomainGameDev }

/** Banking. */
const domainBanking = /*#__PURE__*/ l.token($nsid, 'domainBanking')

export { domainBanking }

/** Banking. */
const DomainBanking = /*#__PURE__*/ domainBanking.value

/** Banking. */
type DomainBanking = typeof DomainBanking

export { DomainBanking }

/** Fintech. */
const domainFintech = /*#__PURE__*/ l.token($nsid, 'domainFintech')

export { domainFintech }

/** Fintech. */
const DomainFintech = /*#__PURE__*/ domainFintech.value

/** Fintech. */
type DomainFintech = typeof DomainFintech

export { DomainFintech }

/** Insurance. */
const domainInsurance = /*#__PURE__*/ l.token($nsid, 'domainInsurance')

export { domainInsurance }

/** Insurance. */
const DomainInsurance = /*#__PURE__*/ domainInsurance.value

/** Insurance. */
type DomainInsurance = typeof DomainInsurance

export { DomainInsurance }

/** Investment Management. */
const domainInvestmentMgmt = /*#__PURE__*/ l.token(
  $nsid,
  'domainInvestmentMgmt',
)

export { domainInvestmentMgmt }

/** Investment Management. */
const DomainInvestmentMgmt = /*#__PURE__*/ domainInvestmentMgmt.value

/** Investment Management. */
type DomainInvestmentMgmt = typeof DomainInvestmentMgmt

export { DomainInvestmentMgmt }

/** Clinical Research. */
const domainClinicalResearch = /*#__PURE__*/ l.token(
  $nsid,
  'domainClinicalResearch',
)

export { domainClinicalResearch }

/** Clinical Research. */
const DomainClinicalResearch = /*#__PURE__*/ domainClinicalResearch.value

/** Clinical Research. */
type DomainClinicalResearch = typeof DomainClinicalResearch

export { DomainClinicalResearch }

/** Health Technology. */
const domainHealthtech = /*#__PURE__*/ l.token($nsid, 'domainHealthtech')

export { domainHealthtech }

/** Health Technology. */
const DomainHealthtech = /*#__PURE__*/ domainHealthtech.value

/** Health Technology. */
type DomainHealthtech = typeof DomainHealthtech

export { DomainHealthtech }

/** Pharmaceuticals. */
const domainPharma = /*#__PURE__*/ l.token($nsid, 'domainPharma')

export { domainPharma }

/** Pharmaceuticals. */
const DomainPharma = /*#__PURE__*/ domainPharma.value

/** Pharmaceuticals. */
type DomainPharma = typeof DomainPharma

export { DomainPharma }

/** Higher Education. */
const domainHigherEd = /*#__PURE__*/ l.token($nsid, 'domainHigherEd')

export { domainHigherEd }

/** Higher Education. */
const DomainHigherEd = /*#__PURE__*/ domainHigherEd.value

/** Higher Education. */
type DomainHigherEd = typeof DomainHigherEd

export { DomainHigherEd }

/** Education Technology. */
const domainEdtech = /*#__PURE__*/ l.token($nsid, 'domainEdtech')

export { domainEdtech }

/** Education Technology. */
const DomainEdtech = /*#__PURE__*/ domainEdtech.value

/** Education Technology. */
type DomainEdtech = typeof DomainEdtech

export { DomainEdtech }

/** Primary & Secondary Education. */
const domainPrimarySecondary = /*#__PURE__*/ l.token(
  $nsid,
  'domainPrimarySecondary',
)

export { domainPrimarySecondary }

/** Primary & Secondary Education. */
const DomainPrimarySecondary = /*#__PURE__*/ domainPrimarySecondary.value

/** Primary & Secondary Education. */
type DomainPrimarySecondary = typeof DomainPrimarySecondary

export { DomainPrimarySecondary }

/** Journalism. */
const domainJournalism = /*#__PURE__*/ l.token($nsid, 'domainJournalism')

export { domainJournalism }

/** Journalism. */
const DomainJournalism = /*#__PURE__*/ domainJournalism.value

/** Journalism. */
type DomainJournalism = typeof DomainJournalism

export { DomainJournalism }

/** Film & Video. */
const domainFilmVideo = /*#__PURE__*/ l.token($nsid, 'domainFilmVideo')

export { domainFilmVideo }

/** Film & Video. */
const DomainFilmVideo = /*#__PURE__*/ domainFilmVideo.value

/** Film & Video. */
type DomainFilmVideo = typeof DomainFilmVideo

export { DomainFilmVideo }

/** Gaming & Interactive Media. */
const domainGaming = /*#__PURE__*/ l.token($nsid, 'domainGaming')

export { domainGaming }

/** Gaming & Interactive Media. */
const DomainGaming = /*#__PURE__*/ domainGaming.value

/** Gaming & Interactive Media. */
type DomainGaming = typeof DomainGaming

export { DomainGaming }

/** Advertising & Marketing. */
const domainAdvertising = /*#__PURE__*/ l.token($nsid, 'domainAdvertising')

export { domainAdvertising }

/** Advertising & Marketing. */
const DomainAdvertising = /*#__PURE__*/ domainAdvertising.value

/** Advertising & Marketing. */
type DomainAdvertising = typeof DomainAdvertising

export { DomainAdvertising }

/** E-commerce. */
const domainEcommerce = /*#__PURE__*/ l.token($nsid, 'domainEcommerce')

export { domainEcommerce }

/** E-commerce. */
const DomainEcommerce = /*#__PURE__*/ domainEcommerce.value

/** E-commerce. */
type DomainEcommerce = typeof DomainEcommerce

export { DomainEcommerce }

/** Supply Chain & Fulfillment. */
const domainSupplyChain = /*#__PURE__*/ l.token($nsid, 'domainSupplyChain')

export { domainSupplyChain }

/** Supply Chain & Fulfillment. */
const DomainSupplyChain = /*#__PURE__*/ domainSupplyChain.value

/** Supply Chain & Fulfillment. */
type DomainSupplyChain = typeof DomainSupplyChain

export { DomainSupplyChain }

/** Automotive. */
const domainAutomotive = /*#__PURE__*/ l.token($nsid, 'domainAutomotive')

export { domainAutomotive }

/** Automotive. */
const DomainAutomotive = /*#__PURE__*/ domainAutomotive.value

/** Automotive. */
type DomainAutomotive = typeof DomainAutomotive

export { DomainAutomotive }

/** Aerospace & Defense. */
const domainAerospace = /*#__PURE__*/ l.token($nsid, 'domainAerospace')

export { domainAerospace }

/** Aerospace & Defense. */
const DomainAerospace = /*#__PURE__*/ domainAerospace.value

/** Aerospace & Defense. */
type DomainAerospace = typeof DomainAerospace

export { DomainAerospace }

/** Hardware & Electronics. */
const domainHardware = /*#__PURE__*/ l.token($nsid, 'domainHardware')

export { domainHardware }

/** Hardware & Electronics. */
const DomainHardware = /*#__PURE__*/ domainHardware.value

/** Hardware & Electronics. */
type DomainHardware = typeof DomainHardware

export { DomainHardware }

/** Renewable Energy. */
const domainRenewables = /*#__PURE__*/ l.token($nsid, 'domainRenewables')

export { domainRenewables }

/** Renewable Energy. */
const DomainRenewables = /*#__PURE__*/ domainRenewables.value

/** Renewable Energy. */
type DomainRenewables = typeof DomainRenewables

export { DomainRenewables }

/** Oil & Gas. */
const domainOilGas = /*#__PURE__*/ l.token($nsid, 'domainOilGas')

export { domainOilGas }

/** Oil & Gas. */
const DomainOilGas = /*#__PURE__*/ domainOilGas.value

/** Oil & Gas. */
type DomainOilGas = typeof DomainOilGas

export { DomainOilGas }

/** Climate Tech. */
const domainClimateTech = /*#__PURE__*/ l.token($nsid, 'domainClimateTech')

export { domainClimateTech }

/** Climate Tech. */
const DomainClimateTech = /*#__PURE__*/ domainClimateTech.value

/** Climate Tech. */
type DomainClimateTech = typeof DomainClimateTech

export { DomainClimateTech }

/** Management Consulting. */
const domainManagementConsulting = /*#__PURE__*/ l.token(
  $nsid,
  'domainManagementConsulting',
)

export { domainManagementConsulting }

/** Management Consulting. */
const DomainManagementConsulting =
  /*#__PURE__*/ domainManagementConsulting.value

/** Management Consulting. */
type DomainManagementConsulting = typeof DomainManagementConsulting

export { DomainManagementConsulting }

/** Developer Relations. */
const domainDevrel = /*#__PURE__*/ l.token($nsid, 'domainDevrel')

export { domainDevrel }

/** Developer Relations. */
const DomainDevrel = /*#__PURE__*/ domainDevrel.value

/** Developer Relations. */
type DomainDevrel = typeof DomainDevrel

export { DomainDevrel }

/** HR & Recruitment. */
const domainHrRecruitment = /*#__PURE__*/ l.token($nsid, 'domainHrRecruitment')

export { domainHrRecruitment }

/** HR & Recruitment. */
const DomainHrRecruitment = /*#__PURE__*/ domainHrRecruitment.value

/** HR & Recruitment. */
type DomainHrRecruitment = typeof DomainHrRecruitment

export { DomainHrRecruitment }

/** Intellectual Property. */
const domainIpLaw = /*#__PURE__*/ l.token($nsid, 'domainIpLaw')

export { domainIpLaw }

/** Intellectual Property. */
const DomainIpLaw = /*#__PURE__*/ domainIpLaw.value

/** Intellectual Property. */
type DomainIpLaw = typeof DomainIpLaw

export { DomainIpLaw }

/** Compliance & Regulatory. */
const domainCompliance = /*#__PURE__*/ l.token($nsid, 'domainCompliance')

export { domainCompliance }

/** Compliance & Regulatory. */
const DomainCompliance = /*#__PURE__*/ domainCompliance.value

/** Compliance & Regulatory. */
type DomainCompliance = typeof DomainCompliance

export { DomainCompliance }

/** Human Rights. */
const domainHumanRights = /*#__PURE__*/ l.token($nsid, 'domainHumanRights')

export { domainHumanRights }

/** Human Rights. */
const DomainHumanRights = /*#__PURE__*/ domainHumanRights.value

/** Human Rights. */
type DomainHumanRights = typeof DomainHumanRights

export { DomainHumanRights }

/** Open Source. */
const domainOpenSource = /*#__PURE__*/ l.token($nsid, 'domainOpenSource')

export { domainOpenSource }

/** Open Source. */
const DomainOpenSource = /*#__PURE__*/ domainOpenSource.value

/** Open Source. */
type DomainOpenSource = typeof DomainOpenSource

export { DomainOpenSource }

/** Public Policy. */
const domainPublicPolicy = /*#__PURE__*/ l.token($nsid, 'domainPublicPolicy')

export { domainPublicPolicy }

/** Public Policy. */
const DomainPublicPolicy = /*#__PURE__*/ domainPublicPolicy.value

/** Public Policy. */
type DomainPublicPolicy = typeof DomainPublicPolicy

export { DomainPublicPolicy }

/** Defense & Intelligence. */
const domainDefense = /*#__PURE__*/ l.token($nsid, 'domainDefense')

export { domainDefense }

/** Defense & Intelligence. */
const DomainDefense = /*#__PURE__*/ domainDefense.value

/** Defense & Intelligence. */
type DomainDefense = typeof DomainDefense

export { DomainDefense }

/** Property Technology. */
const domainProptech = /*#__PURE__*/ l.token($nsid, 'domainProptech')

export { domainProptech }

/** Property Technology. */
const DomainProptech = /*#__PURE__*/ domainProptech.value

/** Property Technology. */
type DomainProptech = typeof DomainProptech

export { DomainProptech }

/** Autonomous Vehicles. */
const domainAutonomousVehicles = /*#__PURE__*/ l.token(
  $nsid,
  'domainAutonomousVehicles',
)

export { domainAutonomousVehicles }

/** Autonomous Vehicles. */
const DomainAutonomousVehicles = /*#__PURE__*/ domainAutonomousVehicles.value

/** Autonomous Vehicles. */
type DomainAutonomousVehicles = typeof DomainAutonomousVehicles

export { DomainAutonomousVehicles }

/** Logistics & Warehousing. */
const domainLogistics = /*#__PURE__*/ l.token($nsid, 'domainLogistics')

export { domainLogistics }

/** Logistics & Warehousing. */
const DomainLogistics = /*#__PURE__*/ domainLogistics.value

/** Logistics & Warehousing. */
type DomainLogistics = typeof DomainLogistics

export { DomainLogistics }

/** Agricultural Technology. */
const domainAgritech = /*#__PURE__*/ l.token($nsid, 'domainAgritech')

export { domainAgritech }

/** Agricultural Technology. */
const DomainAgritech = /*#__PURE__*/ domainAgritech.value

/** Agricultural Technology. */
type DomainAgritech = typeof DomainAgritech

export { DomainAgritech }

/** Food Technology & Processing. */
const domainFoodTech = /*#__PURE__*/ l.token($nsid, 'domainFoodTech')

export { domainFoodTech }

/** Food Technology & Processing. */
const DomainFoodTech = /*#__PURE__*/ domainFoodTech.value

/** Food Technology & Processing. */
type DomainFoodTech = typeof DomainFoodTech

export { DomainFoodTech }

/** Hotels & Accommodation. */
const domainHotels = /*#__PURE__*/ l.token($nsid, 'domainHotels')

export { domainHotels }

/** Hotels & Accommodation. */
const DomainHotels = /*#__PURE__*/ domainHotels.value

/** Hotels & Accommodation. */
type DomainHotels = typeof DomainHotels

export { DomainHotels }

/** Travel & Tourism. */
const domainTravelTourism = /*#__PURE__*/ l.token($nsid, 'domainTravelTourism')

export { domainTravelTourism }

/** Travel & Tourism. */
const DomainTravelTourism = /*#__PURE__*/ domainTravelTourism.value

/** Travel & Tourism. */
type DomainTravelTourism = typeof DomainTravelTourism

export { DomainTravelTourism }

/** Food & Beverage. */
const domainFoodBeverage = /*#__PURE__*/ l.token($nsid, 'domainFoodBeverage')

export { domainFoodBeverage }

/** Food & Beverage. */
const DomainFoodBeverage = /*#__PURE__*/ domainFoodBeverage.value

/** Food & Beverage. */
type DomainFoodBeverage = typeof DomainFoodBeverage

export { DomainFoodBeverage }

/** Network Infrastructure. */
const domainNetworkInfra = /*#__PURE__*/ l.token($nsid, 'domainNetworkInfra')

export { domainNetworkInfra }

/** Network Infrastructure. */
const DomainNetworkInfra = /*#__PURE__*/ domainNetworkInfra.value

/** Network Infrastructure. */
type DomainNetworkInfra = typeof DomainNetworkInfra

export { DomainNetworkInfra }

/** Mobile & Wireless Services. */
const domainMobileServices = /*#__PURE__*/ l.token(
  $nsid,
  'domainMobileServices',
)

export { domainMobileServices }

/** Mobile & Wireless Services. */
const DomainMobileServices = /*#__PURE__*/ domainMobileServices.value

/** Mobile & Wireless Services. */
type DomainMobileServices = typeof DomainMobileServices

export { DomainMobileServices }

/** Extraction & Processing. */
const domainExtraction = /*#__PURE__*/ l.token($nsid, 'domainExtraction')

export { domainExtraction }

/** Extraction & Processing. */
const DomainExtraction = /*#__PURE__*/ domainExtraction.value

/** Extraction & Processing. */
type DomainExtraction = typeof DomainExtraction

export { DomainExtraction }

/** Geological Services. */
const domainGeological = /*#__PURE__*/ l.token($nsid, 'domainGeological')

export { domainGeological }

/** Geological Services. */
const DomainGeological = /*#__PURE__*/ domainGeological.value

/** Geological Services. */
type DomainGeological = typeof DomainGeological

export { DomainGeological }

/** Fashion Design. */
const domainFashionDesign = /*#__PURE__*/ l.token($nsid, 'domainFashionDesign')

export { domainFashionDesign }

/** Fashion Design. */
const DomainFashionDesign = /*#__PURE__*/ domainFashionDesign.value

/** Fashion Design. */
type DomainFashionDesign = typeof DomainFashionDesign

export { DomainFashionDesign }

/** Textile Manufacturing. */
const domainTextileManufacturing = /*#__PURE__*/ l.token(
  $nsid,
  'domainTextileManufacturing',
)

export { domainTextileManufacturing }

/** Textile Manufacturing. */
const DomainTextileManufacturing =
  /*#__PURE__*/ domainTextileManufacturing.value

/** Textile Manufacturing. */
type DomainTextileManufacturing = typeof DomainTextileManufacturing

export { DomainTextileManufacturing }

/** Shipping & Freight. */
const domainShipping = /*#__PURE__*/ l.token($nsid, 'domainShipping')

export { domainShipping }

/** Shipping & Freight. */
const DomainShipping = /*#__PURE__*/ domainShipping.value

/** Shipping & Freight. */
type DomainShipping = typeof DomainShipping

export { DomainShipping }

/** Port & Terminal Operations. */
const domainPortOperations = /*#__PURE__*/ l.token(
  $nsid,
  'domainPortOperations',
)

export { domainPortOperations }

/** Port & Terminal Operations. */
const DomainPortOperations = /*#__PURE__*/ domainPortOperations.value

/** Port & Terminal Operations. */
type DomainPortOperations = typeof DomainPortOperations

export { DomainPortOperations }

/** Naval Architecture & Marine Engineering. */
const domainNavalArchitecture = /*#__PURE__*/ l.token(
  $nsid,
  'domainNavalArchitecture',
)

export { domainNavalArchitecture }

/** Naval Architecture & Marine Engineering. */
const DomainNavalArchitecture = /*#__PURE__*/ domainNavalArchitecture.value

/** Naval Architecture & Marine Engineering. */
type DomainNavalArchitecture = typeof DomainNavalArchitecture

export { DomainNavalArchitecture }

/** An industry/domain pair. Industry is required; domain is an optional refinement within the industry. */
type IndustryDomain = {
  $type?: 'id.sifa.defs#industryDomain'

  /**
   * Professional industry sector token.
   */
  industry:
    | 'id.sifa.defs#industryTechnology'
    | 'id.sifa.defs#industryFinance'
    | 'id.sifa.defs#industryHealthcare'
    | 'id.sifa.defs#industryEducation'
    | 'id.sifa.defs#industryMedia'
    | 'id.sifa.defs#industryRetail'
    | 'id.sifa.defs#industryManufacturing'
    | 'id.sifa.defs#industryEnergy'
    | 'id.sifa.defs#industryGovernment'
    | 'id.sifa.defs#industryLegal'
    | 'id.sifa.defs#industryConsulting'
    | 'id.sifa.defs#industryNonprofit'
    | 'id.sifa.defs#industryRealEstate'
    | 'id.sifa.defs#industryTransport'
    | 'id.sifa.defs#industryAgriculture'
    | 'id.sifa.defs#industryHospitality'
    | 'id.sifa.defs#industryTelecom'
    | 'id.sifa.defs#industryMining'
    | 'id.sifa.defs#industryFashion'
    | 'id.sifa.defs#industryMaritime'
    | 'id.sifa.defs#industryOther'
    | l.UnknownString

  /**
   * Professional domain within the selected industry. Optional refinement.
   */
  domain?:
    | 'id.sifa.defs#domainSoftwareEngineering'
    | 'id.sifa.defs#domainDataScience'
    | 'id.sifa.defs#domainCybersecurity'
    | 'id.sifa.defs#domainDevops'
    | 'id.sifa.defs#domainProductDesign'
    | 'id.sifa.defs#domainGameDev'
    | 'id.sifa.defs#domainBanking'
    | 'id.sifa.defs#domainFintech'
    | 'id.sifa.defs#domainInsurance'
    | 'id.sifa.defs#domainInvestmentMgmt'
    | 'id.sifa.defs#domainClinicalResearch'
    | 'id.sifa.defs#domainHealthtech'
    | 'id.sifa.defs#domainPharma'
    | 'id.sifa.defs#domainHigherEd'
    | 'id.sifa.defs#domainEdtech'
    | 'id.sifa.defs#domainPrimarySecondary'
    | 'id.sifa.defs#domainJournalism'
    | 'id.sifa.defs#domainFilmVideo'
    | 'id.sifa.defs#domainGaming'
    | 'id.sifa.defs#domainAdvertising'
    | 'id.sifa.defs#domainEcommerce'
    | 'id.sifa.defs#domainSupplyChain'
    | 'id.sifa.defs#domainAutomotive'
    | 'id.sifa.defs#domainAerospace'
    | 'id.sifa.defs#domainHardware'
    | 'id.sifa.defs#domainRenewables'
    | 'id.sifa.defs#domainOilGas'
    | 'id.sifa.defs#domainClimateTech'
    | 'id.sifa.defs#domainManagementConsulting'
    | 'id.sifa.defs#domainDevrel'
    | 'id.sifa.defs#domainHrRecruitment'
    | 'id.sifa.defs#domainIpLaw'
    | 'id.sifa.defs#domainCompliance'
    | 'id.sifa.defs#domainHumanRights'
    | 'id.sifa.defs#domainOpenSource'
    | 'id.sifa.defs#domainPublicPolicy'
    | 'id.sifa.defs#domainDefense'
    | 'id.sifa.defs#domainProptech'
    | 'id.sifa.defs#domainAutonomousVehicles'
    | 'id.sifa.defs#domainLogistics'
    | 'id.sifa.defs#domainAgritech'
    | 'id.sifa.defs#domainFoodTech'
    | 'id.sifa.defs#domainHotels'
    | 'id.sifa.defs#domainTravelTourism'
    | 'id.sifa.defs#domainFoodBeverage'
    | 'id.sifa.defs#domainNetworkInfra'
    | 'id.sifa.defs#domainMobileServices'
    | 'id.sifa.defs#domainExtraction'
    | 'id.sifa.defs#domainGeological'
    | 'id.sifa.defs#domainFashionDesign'
    | 'id.sifa.defs#domainTextileManufacturing'
    | 'id.sifa.defs#domainShipping'
    | 'id.sifa.defs#domainPortOperations'
    | 'id.sifa.defs#domainNavalArchitecture'
    | l.UnknownString
}

export type { IndustryDomain }

/** An industry/domain pair. Industry is required; domain is an optional refinement within the industry. */
const industryDomain = /*#__PURE__*/ l.typedObject<IndustryDomain>(
  $nsid,
  'industryDomain',
  /*#__PURE__*/ l.object({
    industry: /*#__PURE__*/ l.string<{
      knownValues: [
        'id.sifa.defs#industryTechnology',
        'id.sifa.defs#industryFinance',
        'id.sifa.defs#industryHealthcare',
        'id.sifa.defs#industryEducation',
        'id.sifa.defs#industryMedia',
        'id.sifa.defs#industryRetail',
        'id.sifa.defs#industryManufacturing',
        'id.sifa.defs#industryEnergy',
        'id.sifa.defs#industryGovernment',
        'id.sifa.defs#industryLegal',
        'id.sifa.defs#industryConsulting',
        'id.sifa.defs#industryNonprofit',
        'id.sifa.defs#industryRealEstate',
        'id.sifa.defs#industryTransport',
        'id.sifa.defs#industryAgriculture',
        'id.sifa.defs#industryHospitality',
        'id.sifa.defs#industryTelecom',
        'id.sifa.defs#industryMining',
        'id.sifa.defs#industryFashion',
        'id.sifa.defs#industryMaritime',
        'id.sifa.defs#industryOther',
      ]
    }>(),
    domain: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'id.sifa.defs#domainSoftwareEngineering',
          'id.sifa.defs#domainDataScience',
          'id.sifa.defs#domainCybersecurity',
          'id.sifa.defs#domainDevops',
          'id.sifa.defs#domainProductDesign',
          'id.sifa.defs#domainGameDev',
          'id.sifa.defs#domainBanking',
          'id.sifa.defs#domainFintech',
          'id.sifa.defs#domainInsurance',
          'id.sifa.defs#domainInvestmentMgmt',
          'id.sifa.defs#domainClinicalResearch',
          'id.sifa.defs#domainHealthtech',
          'id.sifa.defs#domainPharma',
          'id.sifa.defs#domainHigherEd',
          'id.sifa.defs#domainEdtech',
          'id.sifa.defs#domainPrimarySecondary',
          'id.sifa.defs#domainJournalism',
          'id.sifa.defs#domainFilmVideo',
          'id.sifa.defs#domainGaming',
          'id.sifa.defs#domainAdvertising',
          'id.sifa.defs#domainEcommerce',
          'id.sifa.defs#domainSupplyChain',
          'id.sifa.defs#domainAutomotive',
          'id.sifa.defs#domainAerospace',
          'id.sifa.defs#domainHardware',
          'id.sifa.defs#domainRenewables',
          'id.sifa.defs#domainOilGas',
          'id.sifa.defs#domainClimateTech',
          'id.sifa.defs#domainManagementConsulting',
          'id.sifa.defs#domainDevrel',
          'id.sifa.defs#domainHrRecruitment',
          'id.sifa.defs#domainIpLaw',
          'id.sifa.defs#domainCompliance',
          'id.sifa.defs#domainHumanRights',
          'id.sifa.defs#domainOpenSource',
          'id.sifa.defs#domainPublicPolicy',
          'id.sifa.defs#domainDefense',
          'id.sifa.defs#domainProptech',
          'id.sifa.defs#domainAutonomousVehicles',
          'id.sifa.defs#domainLogistics',
          'id.sifa.defs#domainAgritech',
          'id.sifa.defs#domainFoodTech',
          'id.sifa.defs#domainHotels',
          'id.sifa.defs#domainTravelTourism',
          'id.sifa.defs#domainFoodBeverage',
          'id.sifa.defs#domainNetworkInfra',
          'id.sifa.defs#domainMobileServices',
          'id.sifa.defs#domainExtraction',
          'id.sifa.defs#domainGeological',
          'id.sifa.defs#domainFashionDesign',
          'id.sifa.defs#domainTextileManufacturing',
          'id.sifa.defs#domainShipping',
          'id.sifa.defs#domainPortOperations',
          'id.sifa.defs#domainNavalArchitecture',
        ]
      }>(),
    ),
  }),
)

export { industryDomain }

/** Language proficiency level. Maps to LinkedIn's five-level scale for lossless import. */
type Proficiency =
  | 'id.sifa.defs#elementary'
  | 'id.sifa.defs#limitedWorking'
  | 'id.sifa.defs#professionalWorking'
  | 'id.sifa.defs#fullProfessional'
  | 'id.sifa.defs#native'
  | l.UnknownString

export type { Proficiency }

/** Language proficiency level. Maps to LinkedIn's five-level scale for lossless import. */
const proficiency = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#elementary',
    'id.sifa.defs#limitedWorking',
    'id.sifa.defs#professionalWorking',
    'id.sifa.defs#fullProfessional',
    'id.sifa.defs#native',
  ]
}>()

export { proficiency }

/** Elementary proficiency. */
const elementary = /*#__PURE__*/ l.token($nsid, 'elementary')

export { elementary }

/** Elementary proficiency. */
const Elementary = /*#__PURE__*/ elementary.value

/** Elementary proficiency. */
type Elementary = typeof Elementary

export { Elementary }

/** Limited working proficiency. */
const limitedWorking = /*#__PURE__*/ l.token($nsid, 'limitedWorking')

export { limitedWorking }

/** Limited working proficiency. */
const LimitedWorking = /*#__PURE__*/ limitedWorking.value

/** Limited working proficiency. */
type LimitedWorking = typeof LimitedWorking

export { LimitedWorking }

/** Professional working proficiency. */
const professionalWorking = /*#__PURE__*/ l.token($nsid, 'professionalWorking')

export { professionalWorking }

/** Professional working proficiency. */
const ProfessionalWorking = /*#__PURE__*/ professionalWorking.value

/** Professional working proficiency. */
type ProfessionalWorking = typeof ProfessionalWorking

export { ProfessionalWorking }

/** Full professional proficiency. */
const fullProfessional = /*#__PURE__*/ l.token($nsid, 'fullProfessional')

export { fullProfessional }

/** Full professional proficiency. */
const FullProfessional = /*#__PURE__*/ fullProfessional.value

/** Full professional proficiency. */
type FullProfessional = typeof FullProfessional

export { FullProfessional }

/** Native or bilingual proficiency. */
const native$0 = /*#__PURE__*/ l.token($nsid, 'native')

export { native$0 as 'native' }

/** Native or bilingual proficiency. */
const Native = /*#__PURE__*/ native$0.value

/** Native or bilingual proficiency. */
type Native = typeof Native

export { Native }

/** Broad category for grouping skills. */
type SkillCategory =
  | 'id.sifa.defs#technical'
  | 'id.sifa.defs#business'
  | 'id.sifa.defs#creative'
  | 'id.sifa.defs#interpersonal'
  | 'id.sifa.defs#industry'
  | 'id.sifa.defs#community'
  | 'id.sifa.defs#security'
  | l.UnknownString

export type { SkillCategory }

/** Broad category for grouping skills. */
const skillCategory = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#technical',
    'id.sifa.defs#business',
    'id.sifa.defs#creative',
    'id.sifa.defs#interpersonal',
    'id.sifa.defs#industry',
    'id.sifa.defs#community',
    'id.sifa.defs#security',
  ]
}>()

export { skillCategory }

/** Technical/engineering skills. */
const technical = /*#__PURE__*/ l.token($nsid, 'technical')

export { technical }

/** Technical/engineering skills. */
const Technical = /*#__PURE__*/ technical.value

/** Technical/engineering skills. */
type Technical = typeof Technical

export { Technical }

/** Business and management skills. */
const business = /*#__PURE__*/ l.token($nsid, 'business')

export { business }

/** Business and management skills. */
const Business = /*#__PURE__*/ business.value

/** Business and management skills. */
type Business = typeof Business

export { Business }

/** Creative and design skills. */
const creative = /*#__PURE__*/ l.token($nsid, 'creative')

export { creative }

/** Creative and design skills. */
const Creative = /*#__PURE__*/ creative.value

/** Creative and design skills. */
type Creative = typeof Creative

export { Creative }

/** Interpersonal and communication skills. */
const interpersonal = /*#__PURE__*/ l.token($nsid, 'interpersonal')

export { interpersonal }

/** Interpersonal and communication skills. */
const Interpersonal = /*#__PURE__*/ interpersonal.value

/** Interpersonal and communication skills. */
type Interpersonal = typeof Interpersonal

export { Interpersonal }

/** Superseded. Language proficiency is its own record type, id.sifa.profile.language, so this is no longer offered as a skill category. Retained because removing a published token would break any consumer referencing it. */
const language = /*#__PURE__*/ l.token($nsid, 'language')

export { language }

/** Superseded. Language proficiency is its own record type, id.sifa.profile.language, so this is no longer offered as a skill category. Retained because removing a published token would break any consumer referencing it. */
const Language = /*#__PURE__*/ language.value

/** Superseded. Language proficiency is its own record type, id.sifa.profile.language, so this is no longer offered as a skill category. Retained because removing a published token would break any consumer referencing it. */
type Language = typeof Language

export { Language }

/** Industry-specific domain knowledge. */
const industry = /*#__PURE__*/ l.token($nsid, 'industry')

export { industry }

/** Industry-specific domain knowledge. */
const Industry = /*#__PURE__*/ industry.value

/** Industry-specific domain knowledge. */
type Industry = typeof Industry

export { Industry }

/** Community building and developer relations skills. */
const community = /*#__PURE__*/ l.token($nsid, 'community')

export { community }

/** Community building and developer relations skills. */
const Community = /*#__PURE__*/ community.value

/** Community building and developer relations skills. */
type Community = typeof Community

export { Community }

/** Security and privacy skills. */
const security = /*#__PURE__*/ l.token($nsid, 'security')

export { security }

/** Security and privacy skills. */
const Security = /*#__PURE__*/ security.value

/** Security and privacy skills. */
type Security = typeof Security

export { Security }

/** The type of opportunity the user is open to. */
type OpenToWorkStatus =
  | 'id.sifa.defs#fullTimeRoles'
  | 'id.sifa.defs#partTimeRoles'
  | 'id.sifa.defs#contractRoles'
  | 'id.sifa.defs#commissions'
  | 'id.sifa.defs#boardPositions'
  | 'id.sifa.defs#mentoringOthers'
  | 'id.sifa.defs#beingMentored'
  | 'id.sifa.defs#collaborations'
  | 'id.sifa.defs#speakingEngagements'
  | l.UnknownString

export type { OpenToWorkStatus }

/** The type of opportunity the user is open to. */
const openToWorkStatus = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#fullTimeRoles',
    'id.sifa.defs#partTimeRoles',
    'id.sifa.defs#contractRoles',
    'id.sifa.defs#commissions',
    'id.sifa.defs#boardPositions',
    'id.sifa.defs#mentoringOthers',
    'id.sifa.defs#beingMentored',
    'id.sifa.defs#collaborations',
    'id.sifa.defs#speakingEngagements',
  ]
}>()

export { openToWorkStatus }

/** Open to full-time employment opportunities. */
const fullTimeRoles = /*#__PURE__*/ l.token($nsid, 'fullTimeRoles')

export { fullTimeRoles }

/** Open to full-time employment opportunities. */
const FullTimeRoles = /*#__PURE__*/ fullTimeRoles.value

/** Open to full-time employment opportunities. */
type FullTimeRoles = typeof FullTimeRoles

export { FullTimeRoles }

/** Open to part-time employment opportunities. */
const partTimeRoles = /*#__PURE__*/ l.token($nsid, 'partTimeRoles')

export { partTimeRoles }

/** Open to part-time employment opportunities. */
const PartTimeRoles = /*#__PURE__*/ partTimeRoles.value

/** Open to part-time employment opportunities. */
type PartTimeRoles = typeof PartTimeRoles

export { PartTimeRoles }

/** Open to B2B contract or project-based freelance work, consulting, contract development. */
const contractRoles = /*#__PURE__*/ l.token($nsid, 'contractRoles')

export { contractRoles }

/** Open to B2B contract or project-based freelance work, consulting, contract development. */
const ContractRoles = /*#__PURE__*/ contractRoles.value

/** Open to B2B contract or project-based freelance work, consulting, contract development. */
type ContractRoles = typeof ContractRoles

export { ContractRoles }

/** Open to commissioned creative work (illustration, design, voice work, music, etc.). */
const commissions = /*#__PURE__*/ l.token($nsid, 'commissions')

export { commissions }

/** Open to commissioned creative work (illustration, design, voice work, music, etc.). */
const Commissions = /*#__PURE__*/ commissions.value

/** Open to commissioned creative work (illustration, design, voice work, music, etc.). */
type Commissions = typeof Commissions

export { Commissions }

/** Open to advisory or board positions. */
const boardPositions = /*#__PURE__*/ l.token($nsid, 'boardPositions')

export { boardPositions }

/** Open to advisory or board positions. */
const BoardPositions = /*#__PURE__*/ boardPositions.value

/** Open to advisory or board positions. */
type BoardPositions = typeof BoardPositions

export { BoardPositions }

/** Open to mentoring others. */
const mentoringOthers = /*#__PURE__*/ l.token($nsid, 'mentoringOthers')

export { mentoringOthers }

/** Open to mentoring others. */
const MentoringOthers = /*#__PURE__*/ mentoringOthers.value

/** Open to mentoring others. */
type MentoringOthers = typeof MentoringOthers

export { MentoringOthers }

/** Open to being mentored. */
const beingMentored = /*#__PURE__*/ l.token($nsid, 'beingMentored')

export { beingMentored }

/** Open to being mentored. */
const BeingMentored = /*#__PURE__*/ beingMentored.value

/** Open to being mentored. */
type BeingMentored = typeof BeingMentored

export { BeingMentored }

/** Open to project collaborations. */
const collaborations = /*#__PURE__*/ l.token($nsid, 'collaborations')

export { collaborations }

/** Open to project collaborations. */
const Collaborations = /*#__PURE__*/ collaborations.value

/** Open to project collaborations. */
type Collaborations = typeof Collaborations

export { Collaborations }

/** Open to speaking engagements (talks, panels, keynotes, workshops). */
const speakingEngagements = /*#__PURE__*/ l.token($nsid, 'speakingEngagements')

export { speakingEngagements }

/** Open to speaking engagements (talks, panels, keynotes, workshops). */
const SpeakingEngagements = /*#__PURE__*/ speakingEngagements.value

/** Open to speaking engagements (talks, panels, keynotes, workshops). */
type SpeakingEngagements = typeof SpeakingEngagements

export { SpeakingEngagements }

/** Platform type for an external account linked to a Sifa profile. */
type ExternalPlatform =
  | 'id.sifa.defs#platformRss'
  | 'id.sifa.defs#platformFediverse'
  | 'id.sifa.defs#platformTwitter'
  | 'id.sifa.defs#platformInstagram'
  | 'id.sifa.defs#platformGithub'
  | 'id.sifa.defs#platformCodeberg'
  | 'id.sifa.defs#platformGitlab'
  | 'id.sifa.defs#platformForgejo'
  | 'id.sifa.defs#platformGitea'
  | 'id.sifa.defs#platformYoutube'
  | 'id.sifa.defs#platformLinkedin'
  | 'id.sifa.defs#platformSubstack'
  | 'id.sifa.defs#platformWebsite'
  | 'id.sifa.defs#platformOrcid'
  | 'id.sifa.defs#platformOther'
  | l.UnknownString

export type { ExternalPlatform }

/** Platform type for an external account linked to a Sifa profile. */
const externalPlatform = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#platformRss',
    'id.sifa.defs#platformFediverse',
    'id.sifa.defs#platformTwitter',
    'id.sifa.defs#platformInstagram',
    'id.sifa.defs#platformGithub',
    'id.sifa.defs#platformCodeberg',
    'id.sifa.defs#platformGitlab',
    'id.sifa.defs#platformForgejo',
    'id.sifa.defs#platformGitea',
    'id.sifa.defs#platformYoutube',
    'id.sifa.defs#platformLinkedin',
    'id.sifa.defs#platformSubstack',
    'id.sifa.defs#platformWebsite',
    'id.sifa.defs#platformOrcid',
    'id.sifa.defs#platformOther',
  ]
}>()

export { externalPlatform }

/** RSS or Atom feed (blog, newsletter, podcast). */
const platformRss = /*#__PURE__*/ l.token($nsid, 'platformRss')

export { platformRss }

/** RSS or Atom feed (blog, newsletter, podcast). */
const PlatformRss = /*#__PURE__*/ platformRss.value

/** RSS or Atom feed (blog, newsletter, podcast). */
type PlatformRss = typeof PlatformRss

export { PlatformRss }

/** Fediverse account (Mastodon, Misskey, Pleroma, etc.). */
const platformFediverse = /*#__PURE__*/ l.token($nsid, 'platformFediverse')

export { platformFediverse }

/** Fediverse account (Mastodon, Misskey, Pleroma, etc.). */
const PlatformFediverse = /*#__PURE__*/ platformFediverse.value

/** Fediverse account (Mastodon, Misskey, Pleroma, etc.). */
type PlatformFediverse = typeof PlatformFediverse

export { PlatformFediverse }

/** Twitter/X account. */
const platformTwitter = /*#__PURE__*/ l.token($nsid, 'platformTwitter')

export { platformTwitter }

/** Twitter/X account. */
const PlatformTwitter = /*#__PURE__*/ platformTwitter.value

/** Twitter/X account. */
type PlatformTwitter = typeof PlatformTwitter

export { PlatformTwitter }

/** Instagram account. */
const platformInstagram = /*#__PURE__*/ l.token($nsid, 'platformInstagram')

export { platformInstagram }

/** Instagram account. */
const PlatformInstagram = /*#__PURE__*/ platformInstagram.value

/** Instagram account. */
type PlatformInstagram = typeof PlatformInstagram

export { PlatformInstagram }

/** GitHub account. */
const platformGithub = /*#__PURE__*/ l.token($nsid, 'platformGithub')

export { platformGithub }

/** GitHub account. */
const PlatformGithub = /*#__PURE__*/ platformGithub.value

/** GitHub account. */
type PlatformGithub = typeof PlatformGithub

export { PlatformGithub }

/** Codeberg account. */
const platformCodeberg = /*#__PURE__*/ l.token($nsid, 'platformCodeberg')

export { platformCodeberg }

/** Codeberg account. */
const PlatformCodeberg = /*#__PURE__*/ platformCodeberg.value

/** Codeberg account. */
type PlatformCodeberg = typeof PlatformCodeberg

export { PlatformCodeberg }

/** GitLab account (gitlab.com or self-hosted). */
const platformGitlab = /*#__PURE__*/ l.token($nsid, 'platformGitlab')

export { platformGitlab }

/** GitLab account (gitlab.com or self-hosted). */
const PlatformGitlab = /*#__PURE__*/ platformGitlab.value

/** GitLab account (gitlab.com or self-hosted). */
type PlatformGitlab = typeof PlatformGitlab

export { PlatformGitlab }

/** Forgejo account on a self-hosted instance other than Codeberg. */
const platformForgejo = /*#__PURE__*/ l.token($nsid, 'platformForgejo')

export { platformForgejo }

/** Forgejo account on a self-hosted instance other than Codeberg. */
const PlatformForgejo = /*#__PURE__*/ platformForgejo.value

/** Forgejo account on a self-hosted instance other than Codeberg. */
type PlatformForgejo = typeof PlatformForgejo

export { PlatformForgejo }

/** Gitea account on a self-hosted instance. */
const platformGitea = /*#__PURE__*/ l.token($nsid, 'platformGitea')

export { platformGitea }

/** Gitea account on a self-hosted instance. */
const PlatformGitea = /*#__PURE__*/ platformGitea.value

/** Gitea account on a self-hosted instance. */
type PlatformGitea = typeof PlatformGitea

export { PlatformGitea }

/** YouTube channel. */
const platformYoutube = /*#__PURE__*/ l.token($nsid, 'platformYoutube')

export { platformYoutube }

/** YouTube channel. */
const PlatformYoutube = /*#__PURE__*/ platformYoutube.value

/** YouTube channel. */
type PlatformYoutube = typeof PlatformYoutube

export { PlatformYoutube }

/** LinkedIn profile. */
const platformLinkedin = /*#__PURE__*/ l.token($nsid, 'platformLinkedin')

export { platformLinkedin }

/** LinkedIn profile. */
const PlatformLinkedin = /*#__PURE__*/ platformLinkedin.value

/** LinkedIn profile. */
type PlatformLinkedin = typeof PlatformLinkedin

export { PlatformLinkedin }

/** Substack newsletter. */
const platformSubstack = /*#__PURE__*/ l.token($nsid, 'platformSubstack')

export { platformSubstack }

/** Substack newsletter. */
const PlatformSubstack = /*#__PURE__*/ platformSubstack.value

/** Substack newsletter. */
type PlatformSubstack = typeof PlatformSubstack

export { PlatformSubstack }

/** Personal or professional website. */
const platformWebsite = /*#__PURE__*/ l.token($nsid, 'platformWebsite')

export { platformWebsite }

/** Personal or professional website. */
const PlatformWebsite = /*#__PURE__*/ platformWebsite.value

/** Personal or professional website. */
type PlatformWebsite = typeof PlatformWebsite

export { PlatformWebsite }

/** ORCID researcher identifier. */
const platformOrcid = /*#__PURE__*/ l.token($nsid, 'platformOrcid')

export { platformOrcid }

/** ORCID researcher identifier. */
const PlatformOrcid = /*#__PURE__*/ platformOrcid.value

/** ORCID researcher identifier. */
type PlatformOrcid = typeof PlatformOrcid

export { PlatformOrcid }

/** Other platform not covered by specific tokens. */
const platformOther = /*#__PURE__*/ l.token($nsid, 'platformOther')

export { platformOther }

/** Other platform not covered by specific tokens. */
const PlatformOther = /*#__PURE__*/ platformOther.value

/** Other platform not covered by specific tokens. */
type PlatformOther = typeof PlatformOther

export { PlatformOther }

/** The role a location plays in a user's professional profile. */
type LocationType =
  | 'id.sifa.defs#locationPrimary'
  | 'id.sifa.defs#locationBusiness'
  | 'id.sifa.defs#locationTravel'
  | l.UnknownString

export type { LocationType }

/** The role a location plays in a user's professional profile. */
const locationType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#locationPrimary',
    'id.sifa.defs#locationBusiness',
    'id.sifa.defs#locationTravel',
  ]
}>()

export { locationType }

/** Primary residence or home location. */
const locationPrimary = /*#__PURE__*/ l.token($nsid, 'locationPrimary')

export { locationPrimary }

/** Primary residence or home location. */
const LocationPrimary = /*#__PURE__*/ locationPrimary.value

/** Primary residence or home location. */
type LocationPrimary = typeof LocationPrimary

export { LocationPrimary }

/** Business or operational location. */
const locationBusiness = /*#__PURE__*/ l.token($nsid, 'locationBusiness')

export { locationBusiness }

/** Business or operational location. */
const LocationBusiness = /*#__PURE__*/ locationBusiness.value

/** Business or operational location. */
type LocationBusiness = typeof LocationBusiness

export { LocationBusiness }

/** Frequent travel or temporary location. */
const locationTravel = /*#__PURE__*/ l.token($nsid, 'locationTravel')

export { locationTravel }

/** Frequent travel or temporary location. */
const LocationTravel = /*#__PURE__*/ locationTravel.value

/** Frequent travel or temporary location. */
type LocationTravel = typeof LocationTravel

export { LocationTravel }

/** A reference to an id.sifa.profile.skill record by AT-URI. No CID is required because skills are mutable records in the same user's repo. */
type SkillRef = {
  $type?: 'id.sifa.defs#skillRef'

  /**
   * AT-URI of the id.sifa.profile.skill record.
   */
  uri: l.AtUriString
}

export type { SkillRef }

/** A reference to an id.sifa.profile.skill record by AT-URI. No CID is required because skills are mutable records in the same user's repo. */
const skillRef = /*#__PURE__*/ l.typedObject<SkillRef>(
  $nsid,
  'skillRef',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { skillRef }

/** A reference to an organization or person named by a record: a human label plus stable machine anchors. The name is a point-in-time snapshot captured when the record was saved; did and entityRef are the durable identity and should be resolved live. Consumers render the name, and follow did or entityRef to reach the current entity. */
type AgentRef = {
  $type?: 'id.sifa.defs#agentRef'

  /**
   * Human-readable label for the organization or person, as it was known when the record was saved. A point-in-time snapshot, not refreshed from a lookup.
   */
  name: string

  /**
   * DID of the referenced organization or person's atproto account, if one exists. The stable identity: it survives handle and name changes.
   */
  did?: l.DidString

  /**
   * Portable, app-neutral identifier for the referenced organization: a Wikidata Q-ID URI, a ROR URI, or an LEI URI, else a resolver URL. Enables deterministic resolution to a canonical entity even before the organization claims an atproto account. Absent for a bare person or a free-text entry.
   */
  entityRef?: l.UriString
}

export type { AgentRef }

/** A reference to an organization or person named by a record: a human label plus stable machine anchors. The name is a point-in-time snapshot captured when the record was saved; did and entityRef are the durable identity and should be resolved live. Consumers render the name, and follow did or entityRef to reach the current entity. */
const agentRef = /*#__PURE__*/ l.typedObject<AgentRef>(
  $nsid,
  'agentRef',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxGraphemes: 256, maxLength: 2560 }),
    did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
    entityRef: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
  }),
)

export { agentRef }

/** Role within a collaborative project. */
type ProjectRole =
  | 'id.sifa.defs#projectOwner'
  | 'id.sifa.defs#projectCore'
  | 'id.sifa.defs#projectContributor'
  | l.UnknownString

export type { ProjectRole }

/** Role within a collaborative project. */
const projectRole = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#projectOwner',
    'id.sifa.defs#projectCore',
    'id.sifa.defs#projectContributor',
  ]
}>()

export { projectRole }

/** Project owner with full management permissions. Multiple owners are supported. */
const projectOwner = /*#__PURE__*/ l.token($nsid, 'projectOwner')

export { projectOwner }

/** Project owner with full management permissions. Multiple owners are supported. */
const ProjectOwner = /*#__PURE__*/ projectOwner.value

/** Project owner with full management permissions. Multiple owners are supported. */
type ProjectOwner = typeof ProjectOwner

export { ProjectOwner }

/** Core team member with elevated involvement. */
const projectCore = /*#__PURE__*/ l.token($nsid, 'projectCore')

export { projectCore }

/** Core team member with elevated involvement. */
const ProjectCore = /*#__PURE__*/ projectCore.value

/** Core team member with elevated involvement. */
type ProjectCore = typeof ProjectCore

export { ProjectCore }

/** Project contributor. */
const projectContributor = /*#__PURE__*/ l.token($nsid, 'projectContributor')

export { projectContributor }

/** Project contributor. */
const ProjectContributor = /*#__PURE__*/ projectContributor.value

/** Project contributor. */
type ProjectContributor = typeof ProjectContributor

export { ProjectContributor }

/** Current status of a collaborative project. */
type ProjectStatus =
  | 'id.sifa.defs#projectActive'
  | 'id.sifa.defs#projectCompleted'
  | 'id.sifa.defs#projectArchived'
  | l.UnknownString

export type { ProjectStatus }

/** Current status of a collaborative project. */
const projectStatus = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#projectActive',
    'id.sifa.defs#projectCompleted',
    'id.sifa.defs#projectArchived',
  ]
}>()

export { projectStatus }

/** Project is actively maintained or in development. */
const projectActive = /*#__PURE__*/ l.token($nsid, 'projectActive')

export { projectActive }

/** Project is actively maintained or in development. */
const ProjectActive = /*#__PURE__*/ projectActive.value

/** Project is actively maintained or in development. */
type ProjectActive = typeof ProjectActive

export { ProjectActive }

/** Project has been completed. */
const projectCompleted = /*#__PURE__*/ l.token($nsid, 'projectCompleted')

export { projectCompleted }

/** Project has been completed. */
const ProjectCompleted = /*#__PURE__*/ projectCompleted.value

/** Project has been completed. */
type ProjectCompleted = typeof ProjectCompleted

export { ProjectCompleted }

/** Project is archived and no longer active. */
const projectArchived = /*#__PURE__*/ l.token($nsid, 'projectArchived')

export { projectArchived }

/** Project is archived and no longer active. */
const ProjectArchived = /*#__PURE__*/ projectArchived.value

/** Project is archived and no longer active. */
type ProjectArchived = typeof ProjectArchived

export { ProjectArchived }

/** What an id.sifa.confirmation record affirms. Open set. */
type ConfirmationRelation =
  | 'id.sifa.defs#coSpeaker'
  | 'id.sifa.defs#projectMember'
  | 'id.sifa.defs#author'
  | 'id.sifa.defs#collaborator'
  | 'id.sifa.defs#colleague'
  | l.UnknownString

export type { ConfirmationRelation }

/** What an id.sifa.confirmation record affirms. Open set. */
const confirmationRelation = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#coSpeaker',
    'id.sifa.defs#projectMember',
    'id.sifa.defs#author',
    'id.sifa.defs#collaborator',
    'id.sifa.defs#colleague',
  ]
}>()

export { confirmationRelation }

/** The named person presented alongside the claimer at the referenced id.sifa.profile.presentationDelivery occasion. */
const coSpeaker = /*#__PURE__*/ l.token($nsid, 'coSpeaker')

export { coSpeaker }

/** The named person presented alongside the claimer at the referenced id.sifa.profile.presentationDelivery occasion. */
const CoSpeaker = /*#__PURE__*/ coSpeaker.value

/** The named person presented alongside the claimer at the referenced id.sifa.profile.presentationDelivery occasion. */
type CoSpeaker = typeof CoSpeaker

export { CoSpeaker }

/** The named person worked on the referenced id.sifa.profile.project. */
const projectMember = /*#__PURE__*/ l.token($nsid, 'projectMember')

export { projectMember }

/** The named person worked on the referenced id.sifa.profile.project. */
const ProjectMember = /*#__PURE__*/ projectMember.value

/** The named person worked on the referenced id.sifa.profile.project. */
type ProjectMember = typeof ProjectMember

export { ProjectMember }

/** The named person co-authored the referenced id.sifa.profile.publication. */
const author = /*#__PURE__*/ l.token($nsid, 'author')

export { author }

/** The named person co-authored the referenced id.sifa.profile.publication. */
const Author = /*#__PURE__*/ author.value

/** The named person co-authored the referenced id.sifa.profile.publication. */
type Author = typeof Author

export { Author }

/** The named person worked alongside the claimer on the referenced id.sifa.profile.involvement. */
const collaborator = /*#__PURE__*/ l.token($nsid, 'collaborator')

export { collaborator }

/** The named person worked alongside the claimer on the referenced id.sifa.profile.involvement. */
const Collaborator = /*#__PURE__*/ collaborator.value

/** The named person worked alongside the claimer on the referenced id.sifa.profile.involvement. */
type Collaborator = typeof Collaborator

export { Collaborator }

/** The confirming person worked with the owner of the referenced id.sifa.profile.position at the same organization. Unlike the other relations, the subject record names its owner rather than the confirming person. An organization account can write this too, but it stays a colleague-level confirmation: the organization-verified tier comes only from an id.sifa.org.employmentAttestation in the organization's own repository. */
const colleague = /*#__PURE__*/ l.token($nsid, 'colleague')

export { colleague }

/** The confirming person worked with the owner of the referenced id.sifa.profile.position at the same organization. Unlike the other relations, the subject record names its owner rather than the confirming person. An organization account can write this too, but it stays a colleague-level confirmation: the organization-verified tier comes only from an id.sifa.org.employmentAttestation in the organization's own repository. */
const Colleague = /*#__PURE__*/ colleague.value

/** The confirming person worked with the owner of the referenced id.sifa.profile.position at the same organization. Unlike the other relations, the subject record names its owner rather than the confirming person. An organization account can write this too, but it stays a colleague-level confirmation: the organization-verified tier comes only from an id.sifa.org.employmentAttestation in the organization's own repository. */
type Colleague = typeof Colleague

export { Colleague }

/** Another person named as a member of a project. A claim by the record author, not a fact: it carries the named person's display name, avatar, and profile link only once they publish a matching id.sifa.confirmation. */
type ProjectMemberRef = {
  $type?: 'id.sifa.defs#projectMemberRef'

  /**
   * DID of the person named as a project member. Any atproto account is allowed.
   */
  did: l.DidString

  /**
   * Role the named person held on the project. Display only: it grants no write access to the project record, which lives in the author's repository.
   */
  role?:
    | 'id.sifa.defs#projectOwner'
    | 'id.sifa.defs#projectCore'
    | 'id.sifa.defs#projectContributor'
    | l.UnknownString

  /**
   * Optional title within the project (e.g. 'Lead Designer', 'Backend Engineer').
   */
  title?: string
}

export type { ProjectMemberRef }

/** Another person named as a member of a project. A claim by the record author, not a fact: it carries the named person's display name, avatar, and profile link only once they publish a matching id.sifa.confirmation. */
const projectMemberRef = /*#__PURE__*/ l.typedObject<ProjectMemberRef>(
  $nsid,
  'projectMemberRef',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    role: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'id.sifa.defs#projectOwner',
          'id.sifa.defs#projectCore',
          'id.sifa.defs#projectContributor',
        ]
      }>(),
    ),
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 128, maxLength: 1280 }),
    ),
  }),
)

export { projectMemberRef }

/** A reference to a record in another repository or lexicon by AT-URI. The CID is optional: it pins a specific version as an integrity hint, but consumers should resolve the AT-URI live so the reference tracks edits to the target. */
type ExternalRecordRef = {
  $type?: 'id.sifa.defs#externalRecordRef'

  /**
   * AT-URI of the referenced record.
   */
  uri: l.AtUriString

  /**
   * Optional CID of a specific version of the referenced record. Used as an integrity hint only; live resolution is by AT-URI.
   */
  cid?: l.CidString
}

export type { ExternalRecordRef }

/** A reference to a record in another repository or lexicon by AT-URI. The CID is optional: it pins a specific version as an integrity hint, but consumers should resolve the AT-URI live so the reference tracks edits to the target. */
const externalRecordRef = /*#__PURE__*/ l.typedObject<ExternalRecordRef>(
  $nsid,
  'externalRecordRef',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  }),
)

export { externalRecordRef }

/** The user's role in a presentation or session. Open set. */
type PresentationRole =
  | 'id.sifa.defs#presenter'
  | 'id.sifa.defs#panelist'
  | 'id.sifa.defs#keynote'
  | 'id.sifa.defs#workshop'
  | 'id.sifa.defs#host'
  | l.UnknownString

export type { PresentationRole }

/** The user's role in a presentation or session. Open set. */
const presentationRole = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#presenter',
    'id.sifa.defs#panelist',
    'id.sifa.defs#keynote',
    'id.sifa.defs#workshop',
    'id.sifa.defs#host',
  ]
}>()

export { presentationRole }

/** A typed link from this work to another version or form of it, such as the published version of a preprint. Values mirror the DataCite relatedIdentifier vocabulary so they round-trip with DataCite and Crossref metadata. */
type RelatedIdentifier = {
  $type?: 'id.sifa.defs#relatedIdentifier'

  /**
   * The related work: a bare DOI ("10.1234/example"), an AT-URI of another record, or a URL, as named by identifierType.
   */
  identifier: string

  /**
   * Kind of identifier. Absent means DOI.
   */
  identifierType?: 'DOI' | 'AT-URI' | 'URL' | l.UnknownString

  /**
   * How this work relates to the identified one, in DataCite relationType terms. For example IsPreprintOf on a preprint points at its published version.
   */
  relationType:
    | 'IsPreprintOf'
    | 'HasPreprint'
    | 'IsPublishedIn'
    | 'IsVersionOf'
    | 'HasVersion'
    | 'IsNewVersionOf'
    | 'IsPreviousVersionOf'
    | 'IsIdenticalTo'
    | l.UnknownString
}

export type { RelatedIdentifier }

/** A typed link from this work to another version or form of it, such as the published version of a preprint. Values mirror the DataCite relatedIdentifier vocabulary so they round-trip with DataCite and Crossref metadata. */
const relatedIdentifier = /*#__PURE__*/ l.typedObject<RelatedIdentifier>(
  $nsid,
  'relatedIdentifier',
  /*#__PURE__*/ l.object({
    identifier: /*#__PURE__*/ l.string({ maxLength: 2048 }),
    identifierType: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        maxLength: 32
        knownValues: ['DOI', 'AT-URI', 'URL']
      }>({ maxLength: 32 }),
    ),
    relationType: /*#__PURE__*/ l.string<{
      maxLength: 64
      knownValues: [
        'IsPreprintOf',
        'HasPreprint',
        'IsPublishedIn',
        'IsVersionOf',
        'HasVersion',
        'IsNewVersionOf',
        'IsPreviousVersionOf',
        'IsIdenticalTo',
      ]
    }>({ maxLength: 64 }),
  }),
)

export { relatedIdentifier }

/** Delivered the session as the speaker or presenter (spoken or non-spoken). */
const presenter = /*#__PURE__*/ l.token($nsid, 'presenter')

export { presenter }

/** Delivered the session as the speaker or presenter (spoken or non-spoken). */
const Presenter = /*#__PURE__*/ presenter.value

/** Delivered the session as the speaker or presenter (spoken or non-spoken). */
type Presenter = typeof Presenter

export { Presenter }

/** Participated as a member of a panel. */
const panelist = /*#__PURE__*/ l.token($nsid, 'panelist')

export { panelist }

/** Participated as a member of a panel. */
const Panelist = /*#__PURE__*/ panelist.value

/** Participated as a member of a panel. */
type Panelist = typeof Panelist

export { Panelist }

/** Gave a keynote address. */
const keynote = /*#__PURE__*/ l.token($nsid, 'keynote')

export { keynote }

/** Gave a keynote address. */
const Keynote = /*#__PURE__*/ keynote.value

/** Gave a keynote address. */
type Keynote = typeof Keynote

export { Keynote }

/** Led or facilitated a workshop or tutorial. */
const workshop = /*#__PURE__*/ l.token($nsid, 'workshop')

export { workshop }

/** Led or facilitated a workshop or tutorial. */
const Workshop = /*#__PURE__*/ workshop.value

/** Led or facilitated a workshop or tutorial. */
type Workshop = typeof Workshop

export { Workshop }

/** Hosted or moderated the session, including acting as MC, moderator, or host of a podcast or livestream recorded there. Organizing the event itself is recorded as an id.sifa.profile.project whose events field references it, not as a delivery role. */
const host = /*#__PURE__*/ l.token($nsid, 'host')

export { host }

/** Hosted or moderated the session, including acting as MC, moderator, or host of a podcast or livestream recorded there. Organizing the event itself is recorded as an id.sifa.profile.project whose events field references it, not as a delivery role. */
const Host = /*#__PURE__*/ host.value

/** Hosted or moderated the session, including acting as MC, moderator, or host of a podcast or livestream recorded there. Organizing the event itself is recorded as an id.sifa.profile.project whose events field references it, not as a delivery role. */
type Host = typeof Host

export { Host }

/** The category of a related link on a presentation. Open set. */
type PresentationLinkType =
  | 'id.sifa.defs#linkSlides'
  | 'id.sifa.defs#linkRecording'
  | 'id.sifa.defs#linkEvent'
  | 'id.sifa.defs#linkRegistration'
  | 'id.sifa.defs#linkWriteup'
  | 'id.sifa.defs#linkOther'
  | l.UnknownString

export type { PresentationLinkType }

/** The category of a related link on a presentation. Open set. */
const presentationLinkType = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#linkSlides',
    'id.sifa.defs#linkRecording',
    'id.sifa.defs#linkEvent',
    'id.sifa.defs#linkRegistration',
    'id.sifa.defs#linkWriteup',
    'id.sifa.defs#linkOther',
  ]
}>()

export { presentationLinkType }

/** Slides or presentation deck. */
const linkSlides = /*#__PURE__*/ l.token($nsid, 'linkSlides')

export { linkSlides }

/** Slides or presentation deck. */
const LinkSlides = /*#__PURE__*/ linkSlides.value

/** Slides or presentation deck. */
type LinkSlides = typeof LinkSlides

export { LinkSlides }

/** Video or audio recording of the presentation. */
const linkRecording = /*#__PURE__*/ l.token($nsid, 'linkRecording')

export { linkRecording }

/** Video or audio recording of the presentation. */
const LinkRecording = /*#__PURE__*/ linkRecording.value

/** Video or audio recording of the presentation. */
type LinkRecording = typeof LinkRecording

export { LinkRecording }

/** The event or session page. */
const linkEvent = /*#__PURE__*/ l.token($nsid, 'linkEvent')

export { linkEvent }

/** The event or session page. */
const LinkEvent = /*#__PURE__*/ linkEvent.value

/** The event or session page. */
type LinkEvent = typeof LinkEvent

export { LinkEvent }

/** Registration or ticket page. */
const linkRegistration = /*#__PURE__*/ l.token($nsid, 'linkRegistration')

export { linkRegistration }

/** Registration or ticket page. */
const LinkRegistration = /*#__PURE__*/ linkRegistration.value

/** Registration or ticket page. */
type LinkRegistration = typeof LinkRegistration

export { LinkRegistration }

/** A long-form write-up, article, or transcript of the talk. */
const linkWriteup = /*#__PURE__*/ l.token($nsid, 'linkWriteup')

export { linkWriteup }

/** A long-form write-up, article, or transcript of the talk. */
const LinkWriteup = /*#__PURE__*/ linkWriteup.value

/** A long-form write-up, article, or transcript of the talk. */
type LinkWriteup = typeof LinkWriteup

export { LinkWriteup }

/** Other related link. */
const linkOther = /*#__PURE__*/ l.token($nsid, 'linkOther')

export { linkOther }

/** Other related link. */
const LinkOther = /*#__PURE__*/ linkOther.value

/** Other related link. */
type LinkOther = typeof LinkOther

export { LinkOther }

/** A related link for a presentation or one of its deliveries. */
type PresentationLink = {
  $type?: 'id.sifa.defs#presentationLink'

  /**
   * The link URL.
   */
  uri: l.UriString

  /**
   * Optional display label (e.g., 'Watch recording', 'Slides').
   */
  label?: string

  /**
   * Optional link category, used to pick an icon. Open set; see id.sifa.defs#presentationLinkType.
   */
  type?:
    | 'id.sifa.defs#linkSlides'
    | 'id.sifa.defs#linkRecording'
    | 'id.sifa.defs#linkEvent'
    | 'id.sifa.defs#linkRegistration'
    | 'id.sifa.defs#linkWriteup'
    | 'id.sifa.defs#linkOther'
    | l.UnknownString
}

export type { PresentationLink }

/** A related link for a presentation or one of its deliveries. */
const presentationLink = /*#__PURE__*/ l.typedObject<PresentationLink>(
  $nsid,
  'presentationLink',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'uri' }),
    label: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 64, maxLength: 640 }),
    ),
    type: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'id.sifa.defs#linkSlides',
          'id.sifa.defs#linkRecording',
          'id.sifa.defs#linkEvent',
          'id.sifa.defs#linkRegistration',
          'id.sifa.defs#linkWriteup',
          'id.sifa.defs#linkOther',
        ]
      }>(),
    ),
  }),
)

export { presentationLink }

/** The nature of an involvement record. */
type InvolvementKind =
  | 'id.sifa.defs#involvementOpenSource'
  | 'id.sifa.defs#involvementCommunity'
  | 'id.sifa.defs#involvementCharity'
  | 'id.sifa.defs#involvementCivic'
  | 'id.sifa.defs#involvementOther'
  | l.UnknownString

export type { InvolvementKind }

/** The nature of an involvement record. */
const involvementKind = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#involvementOpenSource',
    'id.sifa.defs#involvementCommunity',
    'id.sifa.defs#involvementCharity',
    'id.sifa.defs#involvementCivic',
    'id.sifa.defs#involvementOther',
  ]
}>()

export { involvementKind }

/** The user's role in a course: taking it, teaching it, or assisting with it. */
type CourseRole =
  | 'id.sifa.defs#courseTaken'
  | 'id.sifa.defs#courseTaught'
  | 'id.sifa.defs#courseTeachingAssistant'
  | l.UnknownString

export type { CourseRole }

/** The user's role in a course: taking it, teaching it, or assisting with it. */
const courseRole = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#courseTaken',
    'id.sifa.defs#courseTaught',
    'id.sifa.defs#courseTeachingAssistant',
  ]
}>()

export { courseRole }

/** The user took the course as a student. */
const courseTaken = /*#__PURE__*/ l.token($nsid, 'courseTaken')

export { courseTaken }

/** The user took the course as a student. */
const CourseTaken = /*#__PURE__*/ courseTaken.value

/** The user took the course as a student. */
type CourseTaken = typeof CourseTaken

export { CourseTaken }

/** The user taught the course as an instructor or lecturer. */
const courseTaught = /*#__PURE__*/ l.token($nsid, 'courseTaught')

export { courseTaught }

/** The user taught the course as an instructor or lecturer. */
const CourseTaught = /*#__PURE__*/ courseTaught.value

/** The user taught the course as an instructor or lecturer. */
type CourseTaught = typeof CourseTaught

export { CourseTaught }

/** The user assisted with teaching the course, for example as a teaching assistant. */
const courseTeachingAssistant = /*#__PURE__*/ l.token(
  $nsid,
  'courseTeachingAssistant',
)

export { courseTeachingAssistant }

/** The user assisted with teaching the course, for example as a teaching assistant. */
const CourseTeachingAssistant = /*#__PURE__*/ courseTeachingAssistant.value

/** The user assisted with teaching the course, for example as a teaching assistant. */
type CourseTeachingAssistant = typeof CourseTeachingAssistant

export { CourseTeachingAssistant }

/** Open-source contribution or maintainership. */
const involvementOpenSource = /*#__PURE__*/ l.token(
  $nsid,
  'involvementOpenSource',
)

export { involvementOpenSource }

/** Open-source contribution or maintainership. */
const InvolvementOpenSource = /*#__PURE__*/ involvementOpenSource.value

/** Open-source contribution or maintainership. */
type InvolvementOpenSource = typeof InvolvementOpenSource

export { InvolvementOpenSource }

/** Community organizing, moderation, or meetup/event running. */
const involvementCommunity = /*#__PURE__*/ l.token(
  $nsid,
  'involvementCommunity',
)

export { involvementCommunity }

/** Community organizing, moderation, or meetup/event running. */
const InvolvementCommunity = /*#__PURE__*/ involvementCommunity.value

/** Community organizing, moderation, or meetup/event running. */
type InvolvementCommunity = typeof InvolvementCommunity

export { InvolvementCommunity }

/** Charitable or volunteer work for a cause or person. */
const involvementCharity = /*#__PURE__*/ l.token($nsid, 'involvementCharity')

export { involvementCharity }

/** Charitable or volunteer work for a cause or person. */
const InvolvementCharity = /*#__PURE__*/ involvementCharity.value

/** Charitable or volunteer work for a cause or person. */
type InvolvementCharity = typeof InvolvementCharity

export { InvolvementCharity }

/** Board membership, policy, advisory, or public-consultation work. */
const involvementCivic = /*#__PURE__*/ l.token($nsid, 'involvementCivic')

export { involvementCivic }

/** Board membership, policy, advisory, or public-consultation work. */
const InvolvementCivic = /*#__PURE__*/ involvementCivic.value

/** Board membership, policy, advisory, or public-consultation work. */
type InvolvementCivic = typeof InvolvementCivic

export { InvolvementCivic }

/** Other uncompensated involvement. */
const involvementOther = /*#__PURE__*/ l.token($nsid, 'involvementOther')

export { involvementOther }

/** Other uncompensated involvement. */
const InvolvementOther = /*#__PURE__*/ involvementOther.value

/** Other uncompensated involvement. */
type InvolvementOther = typeof InvolvementOther

export { InvolvementOther }

/** How the capital went in. General partner is deliberately absent: running a fund is a role, recorded as an id.sifa.profile.position, and a partner's own commitment to their fund is a limitedPartner entry against that fund. */
type InvestmentRole =
  | 'id.sifa.defs#angelInvestment'
  | 'id.sifa.defs#syndicateInvestment'
  | 'id.sifa.defs#limitedPartner'
  | 'id.sifa.defs#otherInvestment'
  | l.UnknownString

export type { InvestmentRole }

/** How the capital went in. General partner is deliberately absent: running a fund is a role, recorded as an id.sifa.profile.position, and a partner's own commitment to their fund is a limitedPartner entry against that fund. */
const investmentRole = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#angelInvestment',
    'id.sifa.defs#syndicateInvestment',
    'id.sifa.defs#limitedPartner',
    'id.sifa.defs#otherInvestment',
  ]
}>()

export { investmentRole }

/** Direct investment in the person's own name, with the person choosing the deal. */
const angelInvestment = /*#__PURE__*/ l.token($nsid, 'angelInvestment')

export { angelInvestment }

/** Direct investment in the person's own name, with the person choosing the deal. */
const AngelInvestment = /*#__PURE__*/ angelInvestment.value

/** Direct investment in the person's own name, with the person choosing the deal. */
type AngelInvestment = typeof AngelInvestment

export { AngelInvestment }

/** Investment in a deal led by someone else, made through a per-deal pooled vehicle. */
const syndicateInvestment = /*#__PURE__*/ l.token($nsid, 'syndicateInvestment')

export { syndicateInvestment }

/** Investment in a deal led by someone else, made through a per-deal pooled vehicle. */
const SyndicateInvestment = /*#__PURE__*/ syndicateInvestment.value

/** Investment in a deal led by someone else, made through a per-deal pooled vehicle. */
type SyndicateInvestment = typeof SyndicateInvestment

export { SyndicateInvestment }

/** Capital committed to a fund rather than to a company. The person does not choose the fund's deals, and the named entity is the fund itself. */
const limitedPartner = /*#__PURE__*/ l.token($nsid, 'limitedPartner')

export { limitedPartner }

/** Capital committed to a fund rather than to a company. The person does not choose the fund's deals, and the named entity is the fund itself. */
const LimitedPartner = /*#__PURE__*/ limitedPartner.value

/** Capital committed to a fund rather than to a company. The person does not choose the fund's deals, and the named entity is the fund itself. */
type LimitedPartner = typeof LimitedPartner

export { LimitedPartner }

/** A capital position that fits none of the above. */
const otherInvestment = /*#__PURE__*/ l.token($nsid, 'otherInvestment')

export { otherInvestment }

/** A capital position that fits none of the above. */
const OtherInvestment = /*#__PURE__*/ otherInvestment.value

/** A capital position that fits none of the above. */
type OtherInvestment = typeof OtherInvestment

export { OtherInvestment }

/** The company's funding stage at the time the investment was made, not its stage today. */
type InvestmentStage =
  | 'id.sifa.defs#stagePreSeed'
  | 'id.sifa.defs#stageSeed'
  | 'id.sifa.defs#stageSeriesA'
  | 'id.sifa.defs#stageSeriesB'
  | 'id.sifa.defs#stageSeriesCPlus'
  | 'id.sifa.defs#stageGrowth'
  | 'id.sifa.defs#stageSecondary'
  | 'id.sifa.defs#stageOther'
  | l.UnknownString

export type { InvestmentStage }

/** The company's funding stage at the time the investment was made, not its stage today. */
const investmentStage = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#stagePreSeed',
    'id.sifa.defs#stageSeed',
    'id.sifa.defs#stageSeriesA',
    'id.sifa.defs#stageSeriesB',
    'id.sifa.defs#stageSeriesCPlus',
    'id.sifa.defs#stageGrowth',
    'id.sifa.defs#stageSecondary',
    'id.sifa.defs#stageOther',
  ]
}>()

export { investmentStage }

/** Pre-seed round. */
const stagePreSeed = /*#__PURE__*/ l.token($nsid, 'stagePreSeed')

export { stagePreSeed }

/** Pre-seed round. */
const StagePreSeed = /*#__PURE__*/ stagePreSeed.value

/** Pre-seed round. */
type StagePreSeed = typeof StagePreSeed

export { StagePreSeed }

/** Seed round. */
const stageSeed = /*#__PURE__*/ l.token($nsid, 'stageSeed')

export { stageSeed }

/** Seed round. */
const StageSeed = /*#__PURE__*/ stageSeed.value

/** Seed round. */
type StageSeed = typeof StageSeed

export { StageSeed }

/** Series A round. */
const stageSeriesA = /*#__PURE__*/ l.token($nsid, 'stageSeriesA')

export { stageSeriesA }

/** Series A round. */
const StageSeriesA = /*#__PURE__*/ stageSeriesA.value

/** Series A round. */
type StageSeriesA = typeof StageSeriesA

export { StageSeriesA }

/** Series B round. */
const stageSeriesB = /*#__PURE__*/ l.token($nsid, 'stageSeriesB')

export { stageSeriesB }

/** Series B round. */
const StageSeriesB = /*#__PURE__*/ stageSeriesB.value

/** Series B round. */
type StageSeriesB = typeof StageSeriesB

export { StageSeriesB }

/** Series C or later round. */
const stageSeriesCPlus = /*#__PURE__*/ l.token($nsid, 'stageSeriesCPlus')

export { stageSeriesCPlus }

/** Series C or later round. */
const StageSeriesCPlus = /*#__PURE__*/ stageSeriesCPlus.value

/** Series C or later round. */
type StageSeriesCPlus = typeof StageSeriesCPlus

export { StageSeriesCPlus }

/** Growth or late-stage round. */
const stageGrowth = /*#__PURE__*/ l.token($nsid, 'stageGrowth')

export { stageGrowth }

/** Growth or late-stage round. */
const StageGrowth = /*#__PURE__*/ stageGrowth.value

/** Growth or late-stage round. */
type StageGrowth = typeof StageGrowth

export { StageGrowth }

/** Purchase of existing shares from another holder rather than newly issued shares. */
const stageSecondary = /*#__PURE__*/ l.token($nsid, 'stageSecondary')

export { stageSecondary }

/** Purchase of existing shares from another holder rather than newly issued shares. */
const StageSecondary = /*#__PURE__*/ stageSecondary.value

/** Purchase of existing shares from another holder rather than newly issued shares. */
type StageSecondary = typeof StageSecondary

export { StageSecondary }

/** A stage that fits none of the above, including rounds that predate the standard naming. */
const stageOther = /*#__PURE__*/ l.token($nsid, 'stageOther')

export { stageOther }

/** A stage that fits none of the above, including rounds that predate the standard naming. */
const StageOther = /*#__PURE__*/ stageOther.value

/** A stage that fits none of the above, including rounds that predate the standard naming. */
type StageOther = typeof StageOther

export { StageOther }

/** Where the position stands now. Recording a write-off is showing your work; Sifa never derives a hit rate or return from these values. */
type InvestmentStatus =
  | 'id.sifa.defs#investmentActive'
  | 'id.sifa.defs#investmentExited'
  | 'id.sifa.defs#investmentWrittenOff'
  | 'id.sifa.defs#investmentUndisclosed'
  | l.UnknownString

export type { InvestmentStatus }

/** Where the position stands now. Recording a write-off is showing your work; Sifa never derives a hit rate or return from these values. */
const investmentStatus = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#investmentActive',
    'id.sifa.defs#investmentExited',
    'id.sifa.defs#investmentWrittenOff',
    'id.sifa.defs#investmentUndisclosed',
  ]
}>()

export { investmentStatus }

/** The position is still held. */
const investmentActive = /*#__PURE__*/ l.token($nsid, 'investmentActive')

export { investmentActive }

/** The position is still held. */
const InvestmentActive = /*#__PURE__*/ investmentActive.value

/** The position is still held. */
type InvestmentActive = typeof InvestmentActive

export { InvestmentActive }

/** The position was realised through an acquisition, IPO, or secondary sale. */
const investmentExited = /*#__PURE__*/ l.token($nsid, 'investmentExited')

export { investmentExited }

/** The position was realised through an acquisition, IPO, or secondary sale. */
const InvestmentExited = /*#__PURE__*/ investmentExited.value

/** The position was realised through an acquisition, IPO, or secondary sale. */
type InvestmentExited = typeof InvestmentExited

export { InvestmentExited }

/** The company failed or the position was written down to nothing. */
const investmentWrittenOff = /*#__PURE__*/ l.token(
  $nsid,
  'investmentWrittenOff',
)

export { investmentWrittenOff }

/** The company failed or the position was written down to nothing. */
const InvestmentWrittenOff = /*#__PURE__*/ investmentWrittenOff.value

/** The company failed or the position was written down to nothing. */
type InvestmentWrittenOff = typeof InvestmentWrittenOff

export { InvestmentWrittenOff }

/** The person prefers not to say where the position stands. */
const investmentUndisclosed = /*#__PURE__*/ l.token(
  $nsid,
  'investmentUndisclosed',
)

export { investmentUndisclosed }

/** The person prefers not to say where the position stands. */
const InvestmentUndisclosed = /*#__PURE__*/ investmentUndisclosed.value

/** The person prefers not to say where the position stands. */
type InvestmentUndisclosed = typeof InvestmentUndisclosed

export { InvestmentUndisclosed }

/** An optional, deliberately structured amount. Free text was rejected here because an unparseable money string is worse than no amount at all. */
type InvestmentAmount = {
  $type?: 'id.sifa.defs#investmentAmount'

  /**
   * Amount in whole major currency units (euros, not cents). Cheque sizes are round numbers, and whole units avoid the ambiguity of a bare figure.
   */
  value: number

  /**
   * ISO 4217 three-letter currency code, uppercase. Enforced at the app layer.
   */
  currency: string
}

export type { InvestmentAmount }

/** An optional, deliberately structured amount. Free text was rejected here because an unparseable money string is worse than no amount at all. */
const investmentAmount = /*#__PURE__*/ l.typedObject<InvestmentAmount>(
  $nsid,
  'investmentAmount',
  /*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.integer({ minimum: 0 }),
    currency: /*#__PURE__*/ l.string({ minLength: 3, maxLength: 3 }),
  }),
)

export { investmentAmount }

/** A public artifact proving a piece of work. Reusable across involvement, and later projects/publications. */
type ArtifactLink = {
  $type?: 'id.sifa.defs#artifactLink'

  /**
   * URL of the artifact.
   */
  url: l.UriString

  /**
   * What this link points to.
   */
  kind?:
    | 'pull-request'
    | 'issue'
    | 'commit'
    | 'review'
    | 'release'
    | 'talk'
    | 'video'
    | 'slides'
    | 'article'
    | 'thread'
    | 'dataset'
    | 'edit'
    | 'other'
    | l.UnknownString

  /**
   * Optional human-readable label (e.g. 'Merged PR #1234: keep-alive support').
   */
  label?: string
}

export type { ArtifactLink }

/** A public artifact proving a piece of work. Reusable across involvement, and later projects/publications. */
const artifactLink = /*#__PURE__*/ l.typedObject<ArtifactLink>(
  $nsid,
  'artifactLink',
  /*#__PURE__*/ l.object({
    url: /*#__PURE__*/ l.string({ format: 'uri' }),
    kind: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'pull-request',
          'issue',
          'commit',
          'review',
          'release',
          'talk',
          'video',
          'slides',
          'article',
          'thread',
          'dataset',
          'edit',
          'other',
        ]
      }>(),
    ),
    label: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 200, maxLength: 2000 }),
    ),
  }),
)

export { artifactLink }

/** Whether an employment relationship is ongoing or has ended. */
type EmploymentStatus =
  | 'id.sifa.defs#employmentCurrent'
  | 'id.sifa.defs#employmentPast'
  | l.UnknownString

export type { EmploymentStatus }

/** Whether an employment relationship is ongoing or has ended. */
const employmentStatus = /*#__PURE__*/ l.string<{
  knownValues: ['id.sifa.defs#employmentCurrent', 'id.sifa.defs#employmentPast']
}>()

export { employmentStatus }

/** The person currently holds the position. */
const employmentCurrent = /*#__PURE__*/ l.token($nsid, 'employmentCurrent')

export { employmentCurrent }

/** The person currently holds the position. */
const EmploymentCurrent = /*#__PURE__*/ employmentCurrent.value

/** The person currently holds the position. */
type EmploymentCurrent = typeof EmploymentCurrent

export { EmploymentCurrent }

/** The person held the position in the past. An end date gives the period. */
const employmentPast = /*#__PURE__*/ l.token($nsid, 'employmentPast')

export { employmentPast }

/** The person held the position in the past. An end date gives the period. */
const EmploymentPast = /*#__PURE__*/ employmentPast.value

/** The person held the position in the past. An end date gives the period. */
type EmploymentPast = typeof EmploymentPast

export { EmploymentPast }

/** How Sifa verified an employment: which evidence backs an id.sifa.verification.employment record. */
type VerificationMethod =
  | 'id.sifa.defs#verifiedByEmail'
  | 'id.sifa.defs#verifiedByOrg'
  | 'id.sifa.defs#verifiedByDirectory'
  | 'id.sifa.defs#verifiedByPeer'
  | l.UnknownString

export type { VerificationMethod }

/** How Sifa verified an employment: which evidence backs an id.sifa.verification.employment record. */
const verificationMethod = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#verifiedByEmail',
    'id.sifa.defs#verifiedByOrg',
    'id.sifa.defs#verifiedByDirectory',
    'id.sifa.defs#verifiedByPeer',
  ]
}>()

export { verificationMethod }

/** The person proved control of a mailbox at a domain recognized for the employing organization. Time-limited: the issued record carries expiresAt while this is the only method. */
const verifiedByEmail = /*#__PURE__*/ l.token($nsid, 'verifiedByEmail')

export { verifiedByEmail }

/** The person proved control of a mailbox at a domain recognized for the employing organization. Time-limited: the issued record carries expiresAt while this is the only method. */
const VerifiedByEmail = /*#__PURE__*/ verifiedByEmail.value

/** The person proved control of a mailbox at a domain recognized for the employing organization. Time-limited: the issued record carries expiresAt while this is the only method. */
type VerifiedByEmail = typeof VerifiedByEmail

export { VerifiedByEmail }

/** The organization's own account wrote an id.sifa.org.employmentAttestation for the position. */
const verifiedByOrg = /*#__PURE__*/ l.token($nsid, 'verifiedByOrg')

export { verifiedByOrg }

/** The organization's own account wrote an id.sifa.org.employmentAttestation for the position. */
const VerifiedByOrg = /*#__PURE__*/ verifiedByOrg.value

/** The organization's own account wrote an id.sifa.org.employmentAttestation for the position. */
type VerifiedByOrg = typeof VerifiedByOrg

export { VerifiedByOrg }

/** The organization's directory sync wrote the attestation on the organization's behalf. */
const verifiedByDirectory = /*#__PURE__*/ l.token($nsid, 'verifiedByDirectory')

export { verifiedByDirectory }

/** The organization's directory sync wrote the attestation on the organization's behalf. */
const VerifiedByDirectory = /*#__PURE__*/ verifiedByDirectory.value

/** The organization's directory sync wrote the attestation on the organization's behalf. */
type VerifiedByDirectory = typeof VerifiedByDirectory

export { VerifiedByDirectory }

/** Enough verified colleagues confirmed the position. Reserved: not published in the first version. */
const verifiedByPeer = /*#__PURE__*/ l.token($nsid, 'verifiedByPeer')

export { verifiedByPeer }

/** Enough verified colleagues confirmed the position. Reserved: not published in the first version. */
const VerifiedByPeer = /*#__PURE__*/ verifiedByPeer.value

/** Enough verified colleagues confirmed the position. Reserved: not published in the first version. */
type VerifiedByPeer = typeof VerifiedByPeer

export { VerifiedByPeer }

/** How an id.sifa.org.employmentAttestation came to be written. Absent means manual. */
type AttestationSource =
  | 'id.sifa.defs#attestationManual'
  | 'id.sifa.defs#attestationDirectory'
  | l.UnknownString

export type { AttestationSource }

/** How an id.sifa.org.employmentAttestation came to be written. Absent means manual. */
const attestationSource = /*#__PURE__*/ l.string<{
  knownValues: [
    'id.sifa.defs#attestationManual',
    'id.sifa.defs#attestationDirectory',
  ]
}>()

export { attestationSource }

/** An account holder of the organization confirmed the employment by hand. */
const attestationManual = /*#__PURE__*/ l.token($nsid, 'attestationManual')

export { attestationManual }

/** An account holder of the organization confirmed the employment by hand. */
const AttestationManual = /*#__PURE__*/ attestationManual.value

/** An account holder of the organization confirmed the employment by hand. */
type AttestationManual = typeof AttestationManual

export { AttestationManual }

/** The organization's directory sync (for example SCIM) wrote the attestation. */
const attestationDirectory = /*#__PURE__*/ l.token(
  $nsid,
  'attestationDirectory',
)

export { attestationDirectory }

/** The organization's directory sync (for example SCIM) wrote the attestation. */
const AttestationDirectory = /*#__PURE__*/ attestationDirectory.value

/** The organization's directory sync (for example SCIM) wrote the attestation. */
type AttestationDirectory = typeof AttestationDirectory

export { AttestationDirectory }
